import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {

          introducing: "Introducing iBouge",
          whatIsIBouge: "What is iBouge<0>®</0>?",
          ibougeIntro: "iBouge is a mapping platform that places people, products and information on a global map interface to become more accessible and easier to find by the global internet population, allowing them to interact in new ways.",
          ibougeDescription: "Our patented and unique global map interface categorizes content in a new way and allows people to be found and content to be seen on a global scale. iBouge ® users can connect with anyone in the world and businesses can reach any audience around the globe no matter where they’re located.",
          sign_up: "Sign Up",
          howDoISignUp: "Ok, I’m sold,<1/><0>how do I sign up?</0>",
          products_intro: "Currently we offer 4 products on our map interface:",
          product1: "Meeting people nearby",
          product2: "Global business pages",
          product3: "Map based chat conversations about points of interest",
          product4: "Local events that are pinned on our map and broadcast to anyone who is following that area.",
          whatDifferentiates: "<0>What differentiates the platform </0>from other social media companies?",
          business_price: "Our business pages are only $25 dollars a year with global visibility.",
          signup_cta: "Sign Up Your Business Now for only $25 A Year",

          whoShouldSignUp: "Who should sign up for an account and why?",
          twoTypesAccounts: "We offer two types of accounts.",
          businessAccountDescription: "Our global business pages are tailored to small businesses looking for broad marketing exposure and instant international visibility.",
          businessPageFeatures: "Our business pages list your company info just like Google Maps with map findability but also with the added benefit of group chat, direct messaging, social media features and your own personal wall for company branding and updates.",
          accountTypes: "Individual personal accounts which are free and paid business accounts.",
          soldQuestion: "Ok, I’m sold, how do I sign up?",
          signUpInstructions: "You can sign up as a free user or paid business user on our registration sign up page and select which type of account you’d like in our account Type dropdown.",
          step1: "Step 1",
          step2: "Step 2",
          step3: "Step 3",
          step4: "Step 4",
          done: "Done",
          step1_desc: "Fill out the company details, add the company’s website and a company profile photo.",
          step2_desc: "Enable your browser to share its location with iBouge ® so we can tag your business where it’s located.",
          step3_desc: "Select your top 3 favorite cities to follow for updates to your newsfeed. You can change these cities at any time to explore new places.",
          step4_desc: "Fill out your credit card details to begin your new membership using our secure transaction partner Stripe.",
          enjoyBenefits: "and start enjoying the benefits of using our platform",
          done_steps: "Your business page will automatically activate and then log into the platform.",

          profileUpdated: "Profile has been updated",
          deactivateConfirm: "Are you sure you want to deactivate account",
          enterTextOrImage: "Please Enter Text or Select Image",
          fileTooBig: "File size is too big",
          selectFileFirst: "Please select a file first",
          waitForUpload: "Please wait for media to upload",
          alreadyExistInGroup: "Already Exist In Group",
          enterMsgFirst: "Enter Msg Firstly",
          someFilesTooBig: "Some files were too big and were not selected.",
          enterMessage: "Enter Message",
          enterNewPassword: "Please enter your new password",

          contact_us: "Contact Us",
          write_to_us: "Write to us",
          message_intro: "We would love to hear from you! Please leave us a message and we'll be in touch shortly.",
          your_name: "Your Name",
          subject: "Subject",
          query: "Query",
          send_message: "Send Message",
          message: "Message",
          submit: "Submit",
          global_hq: "Global Headquarters:",
          address: "Redmond, WA 98052, United States",
          hours: "Mon - Fri: 9:00-17:00 PST",

          mission_title: "iBouge's Mission",
          population_globe: "Population Globe",
          expanding_world: "Expanding your world",
          platform_intro: "iBouge's patented platform allows users to find businesses, people and information for any country in the world. Our world map designs create a universally open platform for searching for businesses, connecting to new people and engaging with communities that matter to you.",
          mission_statement: "Our mission is to be the most open information portal on the web for people, businesses and communities.",
          platform_use: "With iBouge, you can find and connect with any individual in the world or find any business globally without typing in a keyword search. Simply click on our map and zoom in to find businesses in places you care about or people you'd like to meet.",
          shops_future: "We will soon be opening shops with products for sale on our platform so you can shop by location.",
          global_connect: "The world is more globally connected than ever before and iBouge is tailored to making your information centralized and open so you have no limits on where to buy from, who you can connect with or which communities you can engage with.",
          fingertips: "With iBouge, the world is at your fingertips.",

          press_statement: "Press Statement",
          month: "MM",
          year: "YYYY",
          search_article: "Search Article",
          lisa_leslie: "Lisa Leslie",
          lisa_title: "No Boundaries: How Lisa Leslie Is Making the World a Little Smaller",
          lisa_updated: "Last updated 7/05/2019",
          lisa_description: "Lisa Leslie got hooked on technology at an early age. She grew up playing games on her family’s computer and took every opportunity to tinker around on the Web.",
          read_article: "Read Article",
          card_cap: "Card cap",
          ibouge_title: "iBouge Launches Global Geo-Networking Platform for Businesses",
          ibouge_updated: "Last updated 7/05/2019",
          ibouge_now_description: "iBouge now offers business pages to companies everywhere. Businesses can register on the mapping platform and instantly reach a global audience.",

          dashboard: "My Dashboard",
          mapOverview: "Map Overview",
          businessProfile: "Business Profile",
          admin: "Admin",
          about: "About",
          contact: "Contact",
          mission: "Mission",
          demo: "Demo",
          press: "Press",
          blog: "Blog",
          privacy: "Privacy",
          terms: "Terms of Service",

          typeToSearch: "Type to Search",
          searching: "Searching...",
          account: "Account",
          notifications: "Notifications",
          inbox: "Inbox",
          logout: "Logout",

          users: "Users",
          events: "Events",
          microblogs: "Microblogs",
          business: "Businesses",
          myProfile: "My Profile",

          globalNewsFeed: "Global NewsFeed",
          whatsOnMind: "What's on your mind?",
          usePhoto: "Use Photo",
          close: "Close",
          usernameWall: "{{username}}'s Wall",
          noStatusUpdates: "No status updates here",
          typing: "Typing",
          hidePostsInfo: "Hiding posts helps iBouge personalise and improve your content",
          hidden: "Hidden",
          post: "Post",
          reportPost: "Report Post",
          deletePost: "Delete Post",
          writeComment: "Write a Comment",
          deleteComment: "Delete Comment",
          addCommentText: "Please add some text in comments",
          noPosts: "Sorry! No Posts available for this location yet. Check out another Location.",
          startConversation: "Start Conversation",
          friendsSelected: "Friend(s) Selected",

          localEvents: "Local Events",
          myMicroblogs: "My Microblogs",
          edit: "Edit",
          addNew: "Add New",

          addCity: "Add City",
          usernameConnection: "{{username}}'s Connections",
          selectOneFriend: "Please Select At least One Friend",
          createGroup: "Create Group",
          noChats: "No Chats available",
          noNotifications: "No notifications",
          addNewEvent: "Add New Event",
          addNewMicroblog: "Add New Microblog",
          addEvent: "Add Event",
          addMicroblog: "Add Microblog",

          signUp: "Sign up",
          signIn: "Sign in",
          login: "Login",
          signupSteps: "Sign up in a few simple steps",
          welcomeLogin: "Welcome! Log in to your account",
          email: "Email Address",
          password: "Password",
          confirmPassword: "Confirm Password",
          type: "Type",
          personalAccount: "Personal Account",
          businessAccount: "Business Account",
          firstName: "First Name",
          lastName: "Last Name",
          gender: "Gender",
          male: "Male",
          female: "Female",
          preferNotSay: "Prefer not to say",
          other: "Other",
          continue: "Continue",
          forgetPassword: "Forget Password?",
          loginMyAccount: "Log in to My Account",
          noAccount: "Don't Have an Account",
          alreadyAccount: "Already have an account?",

          businessCategory: "Business Category",
          subscriptionType: "Subscription Type",
          selectPlan: "Select a plan",
          freePlan: "Free Plan",
          premiumPlan: "Premium Plan",
          businessName: "Business Name",
          fillField: "Please fill in the field Thank You",
          loginVerified: "Please log-in after being verified",
          loginNewAccount: "Please login with your newly created account credentials",
          accountDisabled: "Your account has been disabled by the administrator.",
          premiumOffer: "iBouge Premium offers unlimited followers and prioritized search results for your business page.",

          enterOtp: "Please enter passcode sent to email below:",
          emailVerification: "Email Verification",
          resendOtp: "Resend OTP",
          otpExpires: "OTP expires in {{time}} minutes",
          verify: "Verify",
          restorePasswordText: "Enter your email address and we'll get you back on track.",
          restorePassword: "Restore your password",
          createNewPassword: "Create New Password",
          back: "Back",
          patentNumbers: "Patent numbers",
          copyright: "Copyright",
          allRightsReserved: "All Rights Reserved",

          setup_stepOne: "Setup 1/3",
          setup_profile: "Setup your profile",
          about_me: "About me",
          about_me_placeholder: "Tell us a little bit about yourself",
          my_interests: "My Interests",
          add_interests: "Add Interests",
          my_languages: "My Languages",
          add_languages: "Add Languages",

          setup_stepTwo: "Setup 2/3",
          setup_location: "Setup your location",
          add_your_location: "Add your location: Click on map",
          enable_location: "Please enable location for your browser to tag you in your zip code.",
          tag_neighborhood: "Please tag yourself somewhere in your neighborhood so you can get the best community information and find people around you.",
          location_access: "We need access to your device's location to provide tailored recommendations, relevant content, and improved functionality. Your location is only accessed while the app is open and in use.",

          setup_stepThree: "Setup 3/3",
          select_cities: "Select 3 cities to follow for community news and updates",
          first_city: "First City",
          search: "Search",
          second_city: "Second City",
          third_city: "Third City",
          selectFirstCity: "Please select first city",
          enterOneCity: "Please enter at least one city first",

          step_oneFour: "Setup 1/4",
          businessSummary: "Business Summary",
          businessSummary_placeholder: "Tell us a little bit about your business",
          businessContact: "Business Contact",
          companyWebsite: "Enter company website",
          businessOffers: "What does your business offer?",
          addProduct: "Add Product or Service",

          agreeTerms: "I have read, understood, and agree to the Terms and Conditions.",
          agreePrivacy: "I have read, understood, and agree to the Privacy Policy.",
          continuePrivacy: "Continue to Privacy Policy",
          continuePayment: "Continue to Payment Page",
          createBusinessAccount: "Create my free business iBouge account",
          createPersonalAccount: "Create my free personal iBouge account",
          activateMembership: "Activate Membership",
          planName: "Plan Name",
          planType: "Plan Type",
          planPrice: "Plan Price",
          activateBusinessPage: "Activate my iBouge Business Page",

          summary: "Summary",
          interests: "Interests",
          languages: "Languages",
          businessOffer: "Business Offer",
          openingHours: "Opening Hours",
          timeZone: "Time Zone",
          aboutBusiness: "About Business",
          websiteUrl: "Website URL",
          imageGallery: "Image Gallery",
          noImage: "No image found in gallery",
          addMore: "Add More",
          usernameFollowing: "{{username}} is Following",
          usernameFollowers: "{{username}}'s Followers",
          shareProfile: "Share Profile",
          editCoverPhoto: "Edit Cover Photo",
          urlCopied: "URL added to your clipboard",

          upload: "Upload",
          uploading: "Uploading",
          postDeleted: "This Post has been deleted",
          activatePremium: "Activate Premium Plan",
          sharePress: "Share Press",
          seen: "Seen",
          deletePicture: "Delete Picture",
          savePicture: "Save Picture",
          sharePicture: "Share Picture",
          makeCoverPicture: "Make Cover Picture",
          makeProfilePicture: "Make Profile Picture",
          copyURL: "Copy URL",
          closed: "Closed",
          notSet: "Not Set",
          thankYou: "Thank You!",
          loggingIntoIBouge: "Logging you into iBouge in",
          businessActivated: "Thank you! Your business page has now been activated.",
          shareTo: "Share to",
          stepFourOfFour: "Step 4/4",

          step_OneTwo: "Step 1/2",
          event_details: "Event Details",
          event_name: "Event Name",
          sample_event: "Biggest Pizza Challenge 2022",
          event_category: "Event Category",
          start_date: "Start Date",
          date_format: "mm/dd/yyyy",
          start_time: "Start Time",
          end_time: "End Time",
          event_description: "Event Description",
          cover_photo: "Cover Photo",
          next_to_location: "Next to Location",
          step_TwoTwo: "Step 2/2",
          enter_location: "Enter Location Details",
          add_event_details: "Add event details: Click on map",
          create_event: "Create Event",
          users_interested: "Users are Interested",
          going: "GOING",
          not_going: "NOT GOING",
          invite: "Invite",
          inviteUsers: "Invite Users",
          typeToInvite: "Type here to invite user",
          friendsGoing: "{{number}} of your friends are going.",
          usersInterested: "{{number}} Users Are Interested",
          bookmark: "Bookmark",
          bookmarked: "Bookmarked",

          microblog_name: "Microblog Name",
          add_location: "Add location: Click on map",
          search_address: "Search for an address",
          create: "Create",
          public: "Public",
          private: "Private",
          searchAddress: "Please search for an address",
          selectImage: "Please select the image",

          general: "General",
          location: "Location",
          payments: "Payments",

          companyWebsiteUrl: "Company Website URL",
          settings: "Settings",
          wall_private: "Make my wall private to friends only",
          profile_private: "Make my profile private to my friends only",
          friends_list_private: "Show my friend list only to my friends",
          anyone_follow: "Anyone can follow me",
          accept_messages: "I accept new messages from outside my friend group",
          block_list: "Block List",
          block_users: "Block Users",
          type_to_name: "Type to Name",
          block_list_empty: "Block list is empty",

          wall_notifications: "Wall notifications",
          event_invitations: "Invitations to events",
          friend_requests: "Friend request notifications",
          message_notifications: "Message notifications",
          deactivateAccount: "Deactivate Account",
          deleteAccount: "Delete Account",
          cancel: "Cancel",
          save: "Save",

          topCities: "Top Cities",
          chooseLocations: "Choose up to three locations to follow for updates. Select a city to update to a new city",
          city1: "City 1",
          city2: "City 2",
          city3: "City 3",
          searchCity: "Search for a city",

          flagContent: "Flag Objectionable Content",
          selectReportType: "Select report type",
          unhidePost: "Unhide Post",
          hidePost: "Hide Post",
          cancelSubscription: "Cancel Subscription",
          accountUpdated: "Account has been updated",
          subscriptionAmount: "Subscription Amount",
          subscriptionStartDate: "Subscription Start Date",
          subscriptionEndDate: "Subscription End Date",
          locationUpdated: "Location has been updated",
          notificationsUpdated: "Notifications have been updated",
          privacyUpdated: "Privacy has been updated",
          undo: "Undo",
          block: "Block",
          unblock: "Unblock",
          confirm: "Confirm",
          activateAccount: "Activate Account",
          accountDeactivated: "Oops! Your Account is currently Deactivated",
          confirmDeleteAccount: "Are you sure you want to Delete Account?",
          confirmActivateAccount: "Are you sure you want to Activate Account?",

          delivered: "Delivered",
          download: "Download",
          noChatFound: "No Chat Found",
          messageSeenBy: "Message seen by following user",
          othersCount: "+ {{number}} others",
          notSelectedYet: "Not selected yet",
          nameTyping: "{{name}} is typing...",
          twoTyping: "{{name1}} and {{name2}} are typing...",
          multipleTyping: "{{name1}} and {{number}} others are typing...",
          wallPrivate: "This wall is private",
          profileHidden: "This user's profile is hidden",
          profilePrivate: "This user's profile is private",
          follow: "Follow",
          following: "Following",
          and: "and",
          others: "{{number}} others",
          acceptFriendRequest: "Accept Friend Request",
          friendRequestSent: "Friend Request Sent",
          friends: "Friends",
          confirmUnfollow: "Are you sure you want to unfollow?",
          confirmUnfriend: "Are you sure you want to unfriend?",
          upgradeMessage: "Please upgrade to our premium plan to unlock unlimited followers on your business page.",
          upgrade: "Upgrade",

          noConnectionsFound: "No connections found",
          followersPrivate: "This user's followers list is private",
          friendsPrivate: "This user’s friend list is private",
          addAsFriend: "Add as Friend",
          add: "Add",
          unfriend: "Unfriend",
          unfollow: "unfollow",
          chat: "Chat",
          inviteToChat: "Invite to chat",
        }
      },
      fr: {
        translation: {
          introducing: "Présentation de iBouge",
          whatIsIBouge: "Qu'est-ce que iBouge<0>®</0> ?",
          ibougeIntro: "iBouge est une plateforme de cartographie qui place les personnes, les produits et les informations sur une interface cartographique mondiale afin de les rendre plus accessibles et plus faciles à trouver pour la population mondiale d’internautes, leur permettant ainsi d’interagir de nouvelles manières.",
          ibougeDescription: "Notre interface cartographique mondiale, brevetée et unique, catégorise le contenu d’une nouvelle manière et permet aux personnes d’être trouvées et au contenu d’être vu à l’échelle mondiale. Les utilisateurs de iBouge ® peuvent se connecter avec n’importe qui dans le monde, et les entreprises peuvent atteindre n’importe quel public à travers le globe, quel que soit leur emplacement.",
          sign_up: "S'inscrire",
          howDoISignUp: "D’accord, je suis convaincu,<1/><0>comment m’inscrire ?</0>",
          products_intro: "Nous proposons actuellement 4 produits sur notre interface cartographique :",
          product1: "Rencontrer des personnes à proximité",
          product2: "Pages professionnelles mondiales",
          product3: "Conversations de chat basées sur la carte autour de points d’intérêt",
          product4: "Événements locaux épinglés sur notre carte et diffusés à tous ceux qui suivent cette zone.",
          whatDifferentiates: "<0>Qu’est-ce qui différencie la plateforme </0>des autres entreprises de médias sociaux ?",
          business_price: "Nos pages professionnelles coûtent seulement 25 $ par an avec une visibilité mondiale.",
          signup_cta: "Inscrivez votre entreprise dès maintenant pour seulement 25 $ par an",

          whoShouldSignUp: "Qui devrait s’inscrire et pourquoi ?",
          twoTypesAccounts: "Nous proposons deux types de comptes.",
          businessAccountDescription: "Nos pages professionnelles mondiales sont conçues pour les petites entreprises recherchant une large exposition marketing et une visibilité internationale instantanée.",
          businessPageFeatures: "Nos pages professionnelles répertorient les informations de votre entreprise comme sur Google Maps, avec la possibilité d’être trouvées sur la carte, mais aussi avec les avantages supplémentaires du chat de groupe, de la messagerie directe, des fonctionnalités de médias sociaux et de votre propre mur personnel pour la marque et les mises à jour de votre entreprise.",
          accountTypes: "Comptes personnels individuels gratuits et comptes professionnels payants.",
          soldQuestion: "D’accord, je suis convaincu, comment m’inscrire ?",
          signUpInstructions: "Vous pouvez vous inscrire en tant qu’utilisateur gratuit ou utilisateur professionnel payant sur notre page d’inscription et sélectionner le type de compte que vous souhaitez dans le menu déroulant Type de compte.",
          step1: "Étape 1",
          step2: "Étape 2",
          step3: "Étape 3",
          step4: "Étape 4",
          done: "Terminé",
          step1_desc: "Remplissez les détails de l’entreprise, ajoutez le site Web de l’entreprise et une photo de profil.",
          step2_desc: "Autorisez votre navigateur à partager sa position avec iBouge ® afin que nous puissions localiser votre entreprise à son emplacement.",
          step3_desc: "Sélectionnez vos 3 villes préférées à suivre pour les mises à jour de votre fil d’actualité. Vous pouvez changer ces villes à tout moment pour explorer de nouveaux endroits.",
          step4_desc: "Saisissez les informations de votre carte de crédit pour commencer votre nouvel abonnement via notre partenaire de paiement sécurisé Stripe.",
          enjoyBenefits: "et commencez à profiter des avantages de notre plateforme",
          done_steps: "Votre page professionnelle sera automatiquement activée, puis connectez-vous à la plateforme.",

          profileUpdated: "Le profil a été mis à jour",
          deactivateConfirm: "Êtes-vous sûr de vouloir désactiver le compte ?",
          enterTextOrImage: "Veuillez saisir un texte ou sélectionner une image",
          fileTooBig: "La taille du fichier est trop grande",
          selectFileFirst: "Veuillez d’abord sélectionner un fichier",
          waitForUpload: "Veuillez attendre le téléchargement du média",
          alreadyExistInGroup: "Existe déjà dans le groupe",
          enterMsgFirst: "Saisissez d’abord un message",
          someFilesTooBig: "Certains fichiers étaient trop volumineux et n’ont pas été sélectionnés.",
          enterMessage: "Saisissez un message",
          enterNewPassword: "Veuillez saisir votre nouveau mot de passe",

          contact_us: "Contactez-nous",
          write_to_us: "Écrivez-nous",
          message_intro: "Nous serions ravis d’avoir de vos nouvelles ! Laissez-nous un message et nous vous répondrons sous peu.",
          your_name: "Votre nom",
          subject: "Sujet",
          query: "Demande",
          send_message: "Envoyer le message",
          message: "Message",
          submit: "Soumettre",
          global_hq: "Siège mondial :",
          address: "Redmond, WA 98052, États-Unis",
          hours: "Lun - Ven : 9h00-17h00 PST",

          mission_title: "La mission de iBouge",
          population_globe: "Globe de la population",
          expanding_world: "Élargir votre monde",
          platform_intro: "La plateforme brevetée de iBouge permet aux utilisateurs de trouver des entreprises, des personnes et des informations dans n’importe quel pays du monde. Nos conceptions de carte mondiale créent une plateforme universellement ouverte pour rechercher des entreprises, rencontrer de nouvelles personnes et interagir avec les communautés qui comptent pour vous.",
          mission_statement: "Notre mission est d’être le portail d’information le plus ouvert du web pour les personnes, les entreprises et les communautés.",
          platform_use: "Avec iBouge, vous pouvez trouver et vous connecter avec n’importe quelle personne dans le monde ou trouver n’importe quelle entreprise au niveau mondial sans taper de mot-clé. Cliquez simplement sur notre carte et zoomez pour découvrir des entreprises dans les endroits qui vous intéressent ou des personnes que vous aimeriez rencontrer.",
          shops_future: "Nous ouvrirons bientôt des boutiques proposant des produits à vendre sur notre plateforme afin que vous puissiez acheter selon l’emplacement.",
          global_connect: "Le monde est plus connecté que jamais, et iBouge est conçu pour centraliser et ouvrir vos informations afin que vous n’ayez aucune limite sur vos achats, vos connexions ou les communautés avec lesquelles vous souhaitez interagir.",
          fingertips: "Avec iBouge, le monde est à portée de main.",

          press_statement: "Communiqué de presse",
          month: "MM",
          year: "AAAA",
          search_article: "Rechercher un article",
          lisa_leslie: "Lisa Leslie",
          lisa_title: "Sans frontières : comment Lisa Leslie rend le monde un peu plus petit",
          lisa_updated: "Dernière mise à jour le 07/05/2019",
          lisa_description: "Lisa Leslie s’est passionnée pour la technologie dès son plus jeune âge. Elle a grandi en jouant à des jeux sur l’ordinateur familial et a saisi chaque occasion pour explorer le Web.",
          read_article: "Lire l’article",
          card_cap: "En-tête de carte",
          ibouge_title: "iBouge lance une plateforme de géo-réseautage mondiale pour les entreprises",
          ibouge_updated: "Dernière mise à jour le 07/05/2019",
          ibouge_now_description: "iBouge propose désormais des pages professionnelles pour les entreprises du monde entier. Les entreprises peuvent s’enregistrer sur la plateforme cartographique et atteindre instantanément un public mondial.",

          dashboard: "Mon tableau de bord",
          mapOverview: "Aperçu de la carte",
          businessProfile: "Profil d’entreprise",
          admin: "Administration",
          about: "À propos",
          contact: "Contact",
          mission: "Mission",
          demo: "Démo",
          press: "Presse",
          blog: "Blog",
          privacy: "Confidentialité",
          terms: "Conditions d’utilisation",

          typeToSearch: "Tapez pour rechercher",
          searching: "Recherche en cours...",
          account: "Compte",
          notifications: "Notifications",
          inbox: "Boîte de réception",
          logout: "Se déconnecter",

          users: "Utilisateurs",
          events: "Événements",
          microblogs: "Microblogs",
          business: "Entreprises",
          myProfile: "Mon profil",

          globalNewsFeed: "Fil d’actualités global",
          whatsOnMind: "À quoi pensez-vous ?",
          usePhoto: "Utiliser une photo",
          close: "Fermer",
          usernameWall: "Mur de {{username}}",
          noStatusUpdates: "Aucune mise à jour de statut ici",
          typing: "Saisie en cours",
          hidePostsInfo: "Masquer des publications aide iBouge à personnaliser et améliorer votre contenu",
          hidden: "Masqué",
          post: "Publier",
          reportPost: "Signaler la publication",
          deletePost: "Supprimer la publication",
          writeComment: "Écrire un commentaire",
          deleteComment: "Supprimer le commentaire",
          addCommentText: "Veuillez ajouter du texte dans le commentaire",
          noPosts: "Désolé ! Aucune publication disponible pour cet emplacement pour le moment. Essayez un autre lieu.",
          startConversation: "Commencer une conversation",
          friendsSelected: "Ami(s) sélectionné(s)",

          localEvents: "Événements locaux",
          myMicroblogs: "Mes microblogs",
          edit: "Modifier",
          addNew: "Ajouter",

          addCity: "Ajouter une ville",
          usernameConnection: "Connexions de {{username}}",
          selectOneFriend: "Veuillez sélectionner au moins un ami",
          createGroup: "Créer un groupe",
          noChats: "Aucune discussion disponible",
          noNotifications: "Aucune notification",
          addNewEvent: "Ajouter un nouvel événement",
          addNewMicroblog: "Ajouter un nouveau microblog",
          addEvent: "Ajouter un événement",
          addMicroblog: "Ajouter un microblog",

          signUp: "S'inscrire",
          signIn: "Se connecter",
          login: "Connexion",
          signupSteps: "Inscrivez-vous en quelques étapes simples",
          welcomeLogin: "Bienvenue ! Connectez-vous à votre compte",
          email: "Adresse e-mail",
          password: "Mot de passe",
          confirmPassword: "Confirmer le mot de passe",
          type: "Type",
          personalAccount: "Compte personnel",
          businessAccount: "Compte professionnel",
          firstName: "Prénom",
          lastName: "Nom",
          gender: "Genre",
          male: "Homme",
          female: "Femme",
          preferNotSay: "Préfère ne pas le dire",
          other: "Autre",
          continue: "Continuer",
          forgetPassword: "Mot de passe oublié ?",
          loginMyAccount: "Se connecter à mon compte",
          noAccount: "Vous n'avez pas de compte",
          alreadyAccount: "Vous avez déjà un compte ?",

          businessCategory: "Catégorie d’entreprise",
          subscriptionType: "Type d’abonnement",
          selectPlan: "Sélectionner un forfait",
          freePlan: "Forfait gratuit",
          premiumPlan: "Forfait Premium",
          businessName: "Nom de l’entreprise",
          fillField: "Veuillez remplir le champ, merci",
          loginVerified: "Veuillez vous connecter après vérification",
          loginNewAccount: "Veuillez vous connecter avec les identifiants de votre nouveau compte",
          accountDisabled: "Votre compte a été désactivé par l’administrateur.",
          premiumOffer: "iBouge Premium offre un nombre illimité d’abonnés et des résultats de recherche prioritaires pour votre page professionnelle.",

          enterOtp: "Veuillez saisir le code OTP envoyé à l’e-mail ci-dessous :",
          emailVerification: "Vérification de l’e-mail",
          resendOtp: "Renvoyer le code OTP",
          otpExpires: "Le code OTP expire dans {{time}} minutes",
          verify: "Vérifier",
          restorePasswordText: "Saisissez votre adresse e-mail et nous vous remettrons sur la bonne voie.",
          restorePassword: "Récupérer votre mot de passe",
          createNewPassword: "Créer un nouveau mot de passe",
          back: "Retour",
          patentNumbers: "Numéros de brevet",
          copyright: "Droits d’auteur",
          allRightsReserved: "Tous droits réservés",

          setup_stepOne: "Configuration 1/3",
          setup_profile: "Configurez votre profil",
          about_me: "À propos de moi",
          about_me_placeholder: "Parlez-nous un peu de vous",
          my_interests: "Mes centres d’intérêt",
          add_interests: "Ajouter des centres d’intérêt",
          my_languages: "Mes langues",
          add_languages: "Ajouter des langues",

          setup_stepTwo: "Configuration 2/3",
          setup_location: "Configurez votre position",
          add_your_location: "Ajoutez votre position : cliquez sur la carte",
          enable_location: "Veuillez activer la localisation de votre navigateur afin que nous puissions vous localiser dans votre code postal.",
          tag_neighborhood: "Veuillez vous localiser quelque part dans votre quartier afin d’obtenir les meilleures informations communautaires et de trouver des personnes autour de vous.",
          location_access: "Nous avons besoin d’accéder à la position de votre appareil pour fournir des recommandations personnalisées, du contenu pertinent et une meilleure fonctionnalité. Votre position n’est consultée que lorsque l’application est ouverte et utilisée.",

          setup_stepThree: "Configuration 3/3",
          select_cities: "Sélectionnez 3 villes à suivre pour les actualités et mises à jour communautaires",
          first_city: "Première ville",
          search: "Rechercher",
          second_city: "Deuxième ville",
          third_city: "Troisième ville",
          selectFirstCity: "Veuillez sélectionner la première ville",
          enterOneCity: "Veuillez d’abord saisir au moins une ville",

          step_oneFour: "Configuration 1/4",
          businessSummary: "Résumé de l’entreprise",
          businessSummary_placeholder: "Parlez-nous un peu de votre entreprise",
          businessContact: "Contact professionnel",
          companyWebsite: "Entrez le site Web de l’entreprise",
          businessOffers: "Que propose votre entreprise ?",
          addProduct: "Ajouter un produit ou un service",

          agreeTerms: "J’ai lu, compris et j’accepte les conditions générales.",
          agreePrivacy: "J’ai lu, compris et j’accepte la politique de confidentialité.",
          continuePrivacy: "Continuer vers la politique de confidentialité",
          continuePayment: "Continuer vers la page de paiement",
          createBusinessAccount: "Créer mon compte professionnel iBouge gratuit",
          createPersonalAccount: "Créer mon compte personnel iBouge gratuit",
          activateMembership: "Activer l’abonnement",
          planName: "Nom du forfait",
          planType: "Type de forfait",
          planPrice: "Prix du forfait",
          activateBusinessPage: "Activer ma page professionnelle iBouge",

          summary: "Résumé",
          interests: "Centres d’intérêt",
          languages: "Langues",
          businessOffer: "Offre commerciale",
          openingHours: "Heures d’ouverture",
          timeZone: "Fuseau horaire",
          aboutBusiness: "À propos de l’entreprise",
          websiteUrl: "URL du site Web",
          imageGallery: "Galerie d’images",
          noImage: "Aucune image trouvée dans la galerie",
          addMore: "Ajouter plus",
          usernameFollowing: "{{username}} suit",
          usernameFollowers: "Abonnés de {{username}}",
          shareProfile: "Partager le profil",
          editCoverPhoto: "Modifier la photo de couverture",
          urlCopied: "URL copiée dans votre presse-papiers",

          upload: "Téléverser",
          uploading: "Téléversement en cours",
          postDeleted: "Cette publication a été supprimée",
          activatePremium: "Activer le plan Premium",
          sharePress: "Partager la presse",
          seen: "Vu",
          deletePicture: "Supprimer l’image",
          savePicture: "Enregistrer l’image",
          sharePicture: "Partager l’image",
          makeCoverPicture: "Définir comme photo de couverture",
          makeProfilePicture: "Définir comme photo de profil",
          copyURL: "Copier l’URL",
          closed: "Fermé",
          notSet: "Non défini",
          thankYou: "Merci !",
          loggingIntoIBouge: "Connexion à iBouge dans",
          businessActivated: "Merci ! Votre page professionnelle a été activée.",
          shareTo: "Partager sur",
          stepFourOfFour: "Étape 4/4",

          step_OneTwo: "Étape 1/2",
          event_details: "Détails de l’événement",
          event_name: "Nom de l’événement",
          sample_event: "Le plus grand défi pizza 2022",
          event_category: "Catégorie de l’événement",
          start_date: "Date de début",
          date_format: "jj/mm/aaaa",
          start_time: "Heure de début",
          end_time: "Heure de fin",
          event_description: "Description de l’événement",
          cover_photo: "Photo de couverture",
          next_to_location: "À côté de l’emplacement",
          step_TwoTwo: "Étape 2/2",
          enter_location: "Saisir les détails de l’emplacement",
          add_event_details: "Ajoutez les détails de l’événement : cliquez sur la carte",
          create_event: "Créer un événement",
          users_interested: "Utilisateurs intéressés",
          going: "PARTICIPERA",
          not_going: "NE PARTICIPERA PAS",
          invite: "Inviter",
          inviteUsers: "Inviter des utilisateurs",
          typeToInvite: "Tapez ici pour inviter un utilisateur",
          friendsGoing: "{{number}} de vos amis participent.",
          usersInterested: "{{number}} utilisateurs sont intéressés",
          bookmark: "Marquer",
          bookmarked: "Marqué",

          microblog_name: "Nom du microblog",
          add_location: "Ajouter un emplacement : cliquez sur la carte",
          search_address: "Rechercher une adresse",
          create: "Créer",
          public: "Public",
          private: "Privé",
          searchAddress: "Veuillez rechercher une adresse",
          selectImage: "Veuillez sélectionner une image",

          general: "Général",
          location: "Emplacement",
          payments: "Paiements",

          companyWebsiteUrl: "URL du site Web de l’entreprise",
          settings: "Paramètres",
          wall_private: "Rendre mon mur privé pour mes amis uniquement",
          profile_private: "Rendre mon profil privé pour mes amis uniquement",
          friends_list_private: "Afficher ma liste d’amis uniquement à mes amis",
          anyone_follow: "N’importe qui peut me suivre",
          accept_messages: "J’accepte les nouveaux messages provenant de personnes extérieures à mon groupe d’amis",
          block_list: "Liste de blocage",
          block_users: "Bloquer des utilisateurs",
          type_to_name: "Tapez un nom",
          block_list_empty: "La liste de blocage est vide",

          wall_notifications: "Notifications du mur",
          event_invitations: "Invitations à des événements",
          friend_requests: "Notifications de demande d’ami",
          message_notifications: "Notifications de message",
          deactivateAccount: "Désactiver le compte",
          deleteAccount: "Supprimer le compte",
          cancel: "Annuler",
          save: "Enregistrer",

          topCities: "Villes principales",
          chooseLocations: "Choisissez jusqu’à trois emplacements à suivre pour les mises à jour. Sélectionnez une ville pour la remplacer par une nouvelle.",
          city1: "Ville 1",
          city2: "Ville 2",
          city3: "Ville 3",
          searchCity: "Rechercher une ville",

          flagContent: "Signaler un contenu inapproprié",
          selectReportType: "Sélectionner le type de signalement",
          unhidePost: "Afficher la publication",
          hidePost: "Masquer la publication",
          cancelSubscription: "Annuler l’abonnement",
          accountUpdated: "Le compte a été mis à jour",
          subscriptionAmount: "Montant de l’abonnement",
          subscriptionStartDate: "Date de début de l’abonnement",
          subscriptionEndDate: "Date de fin de l’abonnement",
          locationUpdated: "L’emplacement a été mis à jour",
          notificationsUpdated: "Les notifications ont été mises à jour",
          privacyUpdated: "Les paramètres de confidentialité ont été mis à jour",
          undo: "Annuler",
          block: "Bloquer",
          unblock: "Débloquer",
          confirm: "Confirmer",
          activateAccount: "Activer le compte",
          accountDeactivated: "Oups ! Votre compte est actuellement désactivé",
          confirmDeleteAccount: "Êtes-vous sûr de vouloir supprimer le compte ?",
          confirmActivateAccount: "Êtes-vous sûr de vouloir activer le compte ?",

          delivered: "Livré",
          download: "Télécharger",
          noChatFound: "Aucune discussion trouvée",
          messageSeenBy: "Message vu par l’utilisateur suivant",
          othersCount: "+ {{number}} autres",
          notSelectedYet: "Pas encore sélectionné",
          nameTyping: "{{name}} est en train d’écrire...",
          twoTyping: "{{name1}} et {{name2}} sont en train d’écrire...",
          multipleTyping: "{{name1}} et {{number}} autres sont en train d’écrire...",
          wallPrivate: "Ce mur est privé",
          profileHidden: "Le profil de cet utilisateur est masqué",
          profilePrivate: "Le profil de cet utilisateur est privé",
          follow: "Suivre",
          following: "Abonné",
          and: "et",
          others: "{{number}} autres",
          acceptFriendRequest: "Accepter la demande d’ami",
          friendRequestSent: "Demande d’ami envoyée",
          friends: "Amis",
          confirmUnfollow: "Êtes-vous sûr de vouloir vous désabonner ?",
          confirmUnfriend: "Êtes-vous sûr de vouloir supprimer cet ami ?",
          upgradeMessage: "Veuillez passer à notre plan Premium pour débloquer un nombre illimité d’abonnés sur votre page professionnelle.",
          upgrade: "Mettre à niveau",

          noConnectionsFound: "Aucune connexion trouvée",
          followersPrivate: "La liste des abonnés de cet utilisateur est privée",
          friendsPrivate: "La liste d’amis de cet utilisateur est privée",
          addAsFriend: "Ajouter comme ami",
          add: "Ajouter",
          unfriend: "Supprimer l’ami",
          unfollow: "Se désabonner",
          chat: "Discussion",
          inviteToChat: "Inviter à discuter",

        }
      },
      es: {
        translation: {

          introducing: "Presentando iBouge",
          whatIsIBouge: "¿Qué es iBouge<0>®</0>?",
          ibougeIntro: "iBouge es una plataforma de mapeo que coloca personas, productos e información en una interfaz de mapa global para que sean más accesibles y fáciles de encontrar por la población mundial de Internet, permitiéndoles interactuar de nuevas maneras.",
          ibougeDescription: "Nuestra interfaz de mapa global patentada y única clasifica el contenido de una manera nueva y permite que las personas sean encontradas y que el contenido se vea a nivel mundial. Los usuarios de iBouge ® pueden conectarse con cualquier persona en el mundo y las empresas pueden llegar a cualquier público en todo el mundo sin importar dónde se encuentren.",
          sign_up: "Regístrate",
          howDoISignUp: "De acuerdo, me convenciste,<1/><0>¿cómo me registro?</0>",
          products_intro: "Actualmente ofrecemos 4 productos en nuestra interfaz de mapa:",
          product1: "Conocer personas cercanas",
          product2: "Páginas de negocios globales",
          product3: "Conversaciones de chat basadas en mapas sobre puntos de interés",
          product4: "Eventos locales que están fijados en nuestro mapa y se transmiten a cualquiera que siga esa área.",
          whatDifferentiates: "<0>Qué diferencia la plataforma </0>de otras empresas de redes sociales?",
          business_price: "Nuestras páginas comerciales cuestan solo 25 dólares al año con visibilidad global.",
          signup_cta: "Registra tu negocio ahora por solo 25 $ al año",

          whoShouldSignUp: "¿Quién debería registrarse y por qué?",
          twoTypesAccounts: "Ofrecemos dos tipos de cuentas.",
          businessAccountDescription: "Nuestras páginas comerciales globales están diseñadas para pequeñas empresas que buscan una amplia exposición de marketing y visibilidad internacional instantánea.",
          businessPageFeatures: "Nuestras páginas comerciales enumeran la información de tu empresa al igual que Google Maps, con capacidad de búsqueda en el mapa, pero también con el beneficio adicional de chat grupal, mensajería directa, funciones de redes sociales y tu propio muro personal para la marca y actualizaciones de la empresa.",
          accountTypes: "Cuentas personales individuales gratuitas y cuentas comerciales de pago.",
          soldQuestion: "De acuerdo, me convenciste, ¿cómo me registro?",
          signUpInstructions: "Puedes registrarte como usuario gratuito o como usuario comercial de pago en nuestra página de registro y seleccionar el tipo de cuenta que desees en el menú desplegable Tipo de cuenta.",
          step1: "Paso 1",
          step2: "Paso 2",
          step3: "Paso 3",
          step4: "Paso 4",
          done: "hecho",
          step1_desc: "Completa los detalles de la empresa, agrega el sitio web de la empresa y una foto de perfil de la empresa.",
          step2_desc: "Habilita que tu navegador comparta su ubicación con iBouge ® para que podamos etiquetar tu empresa donde se encuentra.",
          step3_desc: "Selecciona tus 3 ciudades favoritas para seguir las actualizaciones de tu feed de noticias. Puedes cambiar estas ciudades en cualquier momento para explorar nuevos lugares.",
          step4_desc: "Completa los datos de tu tarjeta de crédito para comenzar tu nueva membresía usando nuestro socio de transacciones seguras Stripe.",
          enjoyBenefits: "y comienza a disfrutar los beneficios de usar nuestra plataforma",
          done_steps: "Tu página comercial se activará automáticamente y luego iniciará sesión en la plataforma.",

          profileUpdated: "El perfil ha sido actualizado",
          deactivateConfirm: "¿Estás seguro de que deseas desactivar la cuenta?",
          enterTextOrImage: "Por favor, introduce texto o selecciona una imagen",
          fileTooBig: "El tamaño del archivo es demasiado grande",
          selectFileFirst: "Por favor, selecciona primero un archivo",
          waitForUpload: "Por favor, espera a que se cargue el medio",
          alreadyExistInGroup: "Ya existe en el grupo",
          enterMsgFirst: "Introduce el mensaje primero",
          someFilesTooBig: "Algunos archivos eran demasiado grandes y no fueron seleccionados.",
          enterMessage: "Introduce un mensaje",
          enterNewPassword: "Por favor, introduce tu nueva contraseña",

          contact_us: "Contáctanos",
          write_to_us: "Escríbenos",
          message_intro: "¡Nos encantaría saber de ti! Déjanos un mensaje y nos pondremos en contacto pronto.",
          your_name: "Tu Nombre",
          subject: "Asunto",
          query: "Consulta",
          send_message: "Enviar Mensaje",
          message: "Mensaje",
          submit: "Enviar",
          global_hq: "Sede Global:",
          address: "Redmond, WA 98052, Estados Unidos",
          hours: "Lun - Vie: 9:00-17:00 PST",

          mission_title: "La Misión de iBouge",
          population_globe: "Globo de Población",
          expanding_world: "Expandiendo tu mundo",
          platform_intro: "La plataforma patentada de iBouge permite a los usuarios encontrar negocios, personas e información en cualquier país del mundo...",
          mission_statement: "Nuestra misión es ser el portal de información más abierto en la web para personas, empresas y comunidades.",
          platform_use: "Con iBouge puedes encontrar y conectar con cualquier persona en el mundo o encontrar cualquier negocio global sin escribir palabras clave...",
          shops_future: "Pronto abriremos tiendas con productos a la venta en nuestra plataforma para que puedas comprar por ubicación.",
          global_connect: "El mundo está más conectado globalmente que nunca e iBouge está diseñado para centralizar y abrir tu información...",
          fingertips: "Con iBouge, el mundo está a tu alcance.",

          press_statement: "Comunicado de prensa",
          month: "MM",
          year: "AAAA",
          search_article: "Buscar artículo",
          lisa_leslie: "Lisa Leslie",
          lisa_title: "Sin fronteras: Cómo Lisa Leslie está haciendo el mundo un poco más pequeño",
          lisa_updated: "Última actualización 7/05/2019",
          lisa_description: "Lisa Leslie se enganchó a la tecnología a una edad temprana. Creció jugando en la computadora de su familia y aprovechó cada oportunidad para experimentar en la Web.",
          read_article: "Leer artículo",
          card_cap: "Encabezado de tarjeta",
          ibouge_title: "iBouge lanza plataforma global de geo-redes para empresas",
          ibouge_updated: "Última actualización 7/05/2019",
          ibouge_now_description: "iBouge ahora ofrece páginas comerciales a empresas en todo el mundo. Las empresas pueden registrarse en la plataforma de mapas y llegar instantáneamente a una audiencia global.",

          dashboard: "Mi Panel",
          mapOverview: "Mapa General",
          businessProfile: "Perfil de Negocio",
          admin: "Administrador",
          about: "Acerca de",
          contact: "Contacto",
          mission: "Misión",
          demo: "Demostración",
          press: "Prensa",
          blog: "Blog",
          privacy: "Privacidad",
          terms: "Términos de servicio",

          typeToSearch: "Escribe para buscar",
          searching: "Buscando...",
          account: "Cuenta",
          notifications: "Notificaciones",
          inbox: "Bandeja de entrada",
          logout: "Cerrar sesión",

          users: "Usuarios",
          events: "Eventos",
          microblogs: "Microblogs",
          business: "Negocio",
          myProfile: "Mi perfil",

          globalNewsFeed: "Noticias globales",
          whatsOnMind: "¿Qué estás pensando?",
          usePhoto: "Usar foto",
          close: "Cerrar",
          usernameWall: "Muro de {{username}}",
          noStatusUpdates: "No hay actualizaciones de estado aquí",
          typing: "Escribiendo",
          hidePostsInfo: "Ocultar publicaciones ayuda a iBouge a personalizar y mejorar tu contenido",
          hidden: "Oculto",
          post: "Publicar",
          reportPost: "Reportar publicación",
          deletePost: "Eliminar publicación",
          writeComment: "Escribir un comentario",
          deleteComment: "Eliminar comentario",
          addCommentText: "Por favor agregue algún texto en los comentarios",
          noPosts: "¡Lo sentimos! Aún no hay publicaciones disponibles para esta ubicación. Consulta otra ubicación.",
          startConversation: "Iniciar conversación",
          friendsSelected: "Amigo(s) seleccionado(s)",

          localEvents: "Eventos locales",
          myMicroblogs: "Mis microblogs",
          edit: "Editar",
          addNew: "Agregar nuevo",

          addCity: "Agregar ciudad",
          usernameConnection: "Conexiones de {{username}}",
          selectOneFriend: "Por favor seleccione al menos un amigo",
          createGroup: "Crear grupo",
          noChats: "No hay chats disponibles",
          noNotifications: "Sin notificaciones",
          addNewEvent: "Agregar nuevo evento",
          addNewMicroblog: "Agregar nuevo microblog",
          addEvent: "Agregar evento",
          addMicroblog: "Agregar microblog",

          signUp: "Regístrate",
          signIn: "Iniciar sesión",
          login: "Iniciar sesión",
          signupSteps: "Regístrate en unos sencillos pasos",
          welcomeLogin: "¡Bienvenido! Inicia sesión en tu cuenta",
          email: "Dirección de correo electrónico",
          password: "Contraseña",
          confirmPassword: "Confirmar contraseña",
          type: "Tipo",
          personalAccount: "Cuenta personal",
          businessAccount: "Cuenta de negocios",
          firstName: "Nombre",
          lastName: "Apellido",
          gender: "Género",
          male: "Masculino",
          female: "Femenino",
          preferNotSay: "Prefiero no decirlo",
          other: "Otro",
          continue: "Continuar",
          forgetPassword: "¿Olvidaste tu contraseña?",
          loginMyAccount: "Inicia sesión en mi cuenta",
          noAccount: "¿No tienes una cuenta?",
          alreadyAccount: "¿Ya tienes una cuenta?",

          businessCategory: "Categoría de negocio",
          subscriptionType: "Tipo de suscripción",
          selectPlan: "Selecciona un plan",
          freePlan: "Plan gratuito",
          premiumPlan: "Plan premium",
          businessName: "Nombre del negocio",
          fillField: "Por favor complete el campo, gracias",
          loginVerified: "Por favor inicia sesión después de ser verificado",
          loginNewAccount: "Inicia sesión con las credenciales de tu nueva cuenta",
          accountDisabled: "Tu cuenta ha sido deshabilitada por el administrador.",
          premiumOffer: "iBouge Premium ofrece seguidores ilimitados y resultados de búsqueda priorizados para la página de tu negocio.",

          enterOtp: "Por favor ingresa el OTP enviado al correo electrónico:",
          emailVerification: "Verificación de correo electrónico",
          resendOtp: "Reenviar OTP",
          otpExpires: "El OTP expira en {{time}} minutos",
          verify: "Verificar",
          restorePasswordText: "Introduce tu dirección de correo y te ayudaremos a recuperarla.",
          restorePassword: "Restaurar contraseña",
          createNewPassword: "Crear nueva contraseña",
          back: "Atrás",
          patentNumbers: "Números de patente",
          copyright: "Derechos de autor",
          allRightsReserved: "Todos los derechos reservados",

          setup_stepOne: "Configuración 1/3",
          setup_profile: "Configura tu perfil",
          about_me: "Acerca de mí",
          about_me_placeholder: "Cuéntanos un poco sobre ti",
          my_interests: "Mis intereses",
          add_interests: "Agregar intereses",
          my_languages: "Mis idiomas",
          add_languages: "Agregar idiomas",

          setup_stepTwo: "Configuración 2/3",
          setup_location: "Configura tu ubicación",
          add_your_location: "Agrega tu ubicación: Haz clic en el mapa",
          enable_location: "Por favor, habilita la ubicación en tu navegador para etiquetarte en tu código postal.",
          tag_neighborhood: "Por favor, márcate en tu vecindario para obtener la mejor información comunitaria y encontrar personas a tu alrededor.",
          location_access: "Necesitamos acceder a la ubicación de tu dispositivo para brindar recomendaciones personalizadas, contenido relevante y mejor funcionalidad. Tu ubicación solo se accede mientras la aplicación está abierta y en uso.",

          setup_stepThree: "ConfiThreeación 3/3",
          select_cities: "Selecciona 3 ciudades para seguir noticias y actualizaciones de la comunidad",
          first_city: "Primera Ciudad",
          search: "Buscar",
          second_city: "Segunda Ciudad",
          third_city: "Tercera Ciudad",
          selectFirstCity: "Por favor selecciona primero una ciudad",
          enterOneCity: "Por favor ingresa al menos una ciudad primero",

          step_oneFour: "Configuración 1/4",
          businessSummary: "Resumen del negocio",
          businessSummary_placeholder: "Cuéntanos un poco sobre tu negocio",
          businessContact: "Contacto comercial",
          companyWebsite: "Introduce el sitio web de la empresa",
          businessOffers: "¿Qué ofrece tu negocio?",
          addProduct: "Agregar producto o servicio",

          agreeTerms: "He leído, entendido y acepto los Términos y Condiciones.",
          agreePrivacy: "He leído, entendido y acepto la Política de Privacidad.",
          continuePrivacy: "Continuar a la Política de Privacidad",
          continuePayment: "Continuar a la página de pago",
          createBusinessAccount: "Crear mi cuenta iBouge de negocio gratuita",
          createPersonalAccount: "Crear mi cuenta iBouge personal gratuita",
          activateMembership: "Activar membresía",
          planName: "Nombre del plan",
          planType: "Tipo de plan",
          planPrice: "Precio del plan",
          activateBusinessPage: "Activar mi página de negocio iBouge",

          summary: "Resumen",
          interests: "Intereses",
          languages: "Idiomas",
          businessOffer: "Oferta de negocio",
          openingHours: "Horario de apertura",
          timeZone: "Zona horaria",
          aboutBusiness: "Acerca del negocio",
          websiteUrl: "URL del sitio web",
          imageGallery: "Galería de imágenes",
          noImage: "No se encontraron imágenes en la galería",
          addMore: "Agregar más",
          usernameFollowing: "{{username}} está siguiendo",
          usernameFollowers: "Seguidores de {{username}}",
          shareProfile: "Compartir perfil",
          editCoverPhoto: "Editar foto de portada",
          urlCopied: "URL copiada al portapapeles",

          upload: "Subir",
          uploading: "Subiendo",
          postDeleted: "Esta publicación ha sido eliminada",
          activatePremium: "Activar plan premium",
          sharePress: "Compartir publicación",
          seen: "Visto",
          deletePicture: "Eliminar imagen",
          savePicture: "Guardar imagen",
          sharePicture: "Compartir imagen",
          makeCoverPicture: "Hacer imagen de portada",
          makeProfilePicture: "Hacer imagen de perfil",
          copyURL: "Copiar URL",
          closed: "Cerrado",
          notSet: "No establecido",
          thankYou: "¡Gracias!",
          loggingIntoIBouge: "Iniciando sesión en iBouge en",
          businessActivated: "¡Gracias! Tu página comercial ha sido activada.",
          shareTo: "Compartir en",
          stepFourOfFour: "Paso 4/4",

          step_OneTwo: "Paso 1/2",
          event_details: "Detalles del Evento",
          event_name: "Nombre del Evento",
          sample_event: "El Mayor Desafío de Pizza 2022",
          event_category: "Categoría del Evento",
          start_date: "Fecha de Inicio",
          date_format: "dd/mm/aaaa",
          start_time: "Hora de Inicio",
          end_time: "Hora de Finalización",
          event_description: "Descripción del Evento",
          cover_photo: "Foto de Portada",
          next_to_location: "Siguiente a Ubicación",
          step_TwoTwo: "Paso 2/2",
          enter_location: "Ingresar Detalles de Ubicación",
          add_event_details: "Agregar detalles del evento: Haz clic en el mapa",
          create_event: "Crear Evento",
          users_interested: "Usuarios interesados",
          going: "ASISTIRÉ",
          not_going: "NO ASISTIRÁ",
          invite: "Invitar",
          inviteUsers: "Invitar usuarios",
          typeToInvite: "Escribe aquí para invitar a un usuario",
          friendsGoing: "{{number}} de tus amigos asistirán.",
          usersInterested: "{{number}} usuarios están interesados",
          bookmark: "Guardar",
          bookmarked: "Marcado",

          microblog_name: "Nombre del Microblog",
          add_location: "Agregar ubicación: Haz clic en el mapa",
          search_address: "Buscar una dirección",
          create: "Crear",
          public: "Público",
          private: "Privado",
          searchAddress: "Por favor, busca una dirección",
          selectImage: "Por favor, selecciona la imagen",

          general: "General",
          location: "Ubicación",
          payments: "Pagos",

          companyWebsiteUrl: "URL del sitio web de la empresa",
          settings: "Configuraciones",
          wall_private: "Hacer que mi muro sea privado solo para amigos",
          profile_private: "Hacer que mi perfil sea privado solo para mis amigos",
          friends_list_private: "Mostrar mi lista de amigos solo a mis amigos",
          anyone_follow: "Cualquiera puede seguirme",
          accept_messages: "Acepto nuevos mensajes de fuera de mi grupo de amigos",
          block_list: "Lista de bloqueados",
          block_users: "Bloquear usuarios",
          type_to_name: "Escribe un nombre",
          block_list_empty: "La lista de bloqueados está vacía",

          wall_notifications: "Notificaciones del muro",
          event_invitations: "Invitaciones a eventos",
          friend_requests: "Notificaciones de solicitudes de amistad",
          message_notifications: "Notificaciones de mensajes",
          deactivateAccount: "Desactivar cuenta",
          deleteAccount: "Eliminar cuenta",
          cancel: "Cancelar",
          save: "Guardar",

          topCities: "Ciudades principales",
          chooseLocations: "Elige hasta tres ubicaciones para seguir actualizaciones. Selecciona una ciudad para cambiar a otra nueva",
          city1: "Ciudad 1",
          city2: "Ciudad 2",
          city3: "Ciudad 3",
          searchCity: "Buscar una ciudad",

          flagContent: "Marcar contenido objetable",
          selectReportType: "Seleccionar tipo de informe",
          unhidePost: "Mostrar publicación",
          hidePost: "Ocultar publicación",
          cancelSubscription: "Cancelar suscripción",
          accountUpdated: "La cuenta ha sido actualizada",
          subscriptionAmount: "Monto de la suscripción",
          subscriptionStartDate: "Fecha de inicio de la suscripción",
          subscriptionEndDate: "Fecha de finalización de la suscripción",
          locationUpdated: "La ubicación ha sido actualizada",
          notificationsUpdated: "Las notificaciones han sido actualizadas",
          privacyUpdated: "La privacidad ha sido actualizada",
          undo: "Deshacer",
          block: "Bloquear",
          unblock: "Desbloquear",
          confirm: "Confirmar",
          activateAccount: "Activar cuenta",
          accountDeactivated: "¡Ups! Tu cuenta está actualmente desactivada",
          confirmDeleteAccount: "¿Estás seguro de que deseas eliminar la cuenta?",
          confirmActivateAccount: "¿Estás seguro de que deseas activar la cuenta?",

          delivered: "Entregado",
          download: "Descargar",
          noChatFound: "No se encontró chat",
          messageSeenBy: "Mensaje visto por el siguiente usuario",
          othersCount: "+ {{number}} más",
          notSelectedYet: "Aún no seleccionado",
          nameTyping: "{{name}} está escribiendo...",
          twoTyping: "{{name1}} y {{name2}} están escribiendo...",
          multipleTyping: "{{name1}} y {{number}} más están escribiendo...",
          wallPrivate: "Este muro es privado",
          profileHidden: "El perfil de este usuario está oculto",
          profilePrivate: "El perfil de este usuario es privado",
          follow: "Seguir",
          following: "Siguiendo",
          and: "y",
          others: "{{number}} más",
          acceptFriendRequest: "Aceptar solicitud de amistad",
          friendRequestSent: "Solicitud de amistad enviada",
          friends: "Amigos",
          confirmUnfollow: "¿Estás seguro de que deseas dejar de seguir?",
          confirmUnfriend: "¿Estás seguro de que deseas eliminar a este amigo?",
          upgradeMessage: "Actualiza a nuestro plan premium para desbloquear seguidores ilimitados en tu página de negocios.",
          upgrade: "Actualizar",

          noConnectionsFound: "No se encontraron conexiones",
          followersPrivate: "La lista de seguidores de este usuario es privada",
          friendsPrivate: "La lista de amigos de este usuario es privada",
          addAsFriend: "Agregar como amigo",
          add: "Agregar",
          unfriend: "Eliminar amigo",
          unfollow: "dejar de seguir",
          chat: "Chat",
          inviteToChat: "Invitar al chat",
        }
      },
      de: {
        translation: {

          introducing: "Einführung in iBouge",
          whatIsIBouge: "Was ist iBouge<0>®</0>?",
          ibougeIntro: "iBouge ist eine Kartenplattform, die Menschen, Produkte und Informationen auf einer globalen Kartenoberfläche platziert, um sie für die weltweite Internetbevölkerung besser zugänglich und leichter auffindbar zu machen, sodass sie auf neue Weise interagieren können.",
          ibougeDescription: "Unsere patentierte und einzigartige globale Kartenoberfläche kategorisiert Inhalte auf eine neue Art und Weise und ermöglicht es, dass Menschen gefunden und Inhalte weltweit gesehen werden. iBouge ® Benutzer können sich mit jedem auf der Welt verbinden und Unternehmen können ihr Publikum weltweit erreichen, unabhängig davon, wo sie sich befinden.",
          sign_up: "Registrieren",
          howDoISignUp: "Okay, ich bin überzeugt,<1/><0>wie melde ich mich an?</0>",
          products_intro: "Derzeit bieten wir 4 Produkte auf unserer Kartenoberfläche an:",
          product1: "Leute in der Nähe treffen",
          product2: "Globale Unternehmensseiten",
          product3: "Kartenbasierte Chat-Gespräche über interessante Orte",
          product4: "Lokale Veranstaltungen, die auf unserer Karte markiert und an alle gesendet werden, die diesem Bereich folgen.",
          whatDifferentiates: "<0>Was die Plattform </0>von anderen sozialen Medienunternehmen unterscheidet?",
          business_price: "Unsere Unternehmensseiten kosten nur 25 $ pro Jahr mit globaler Sichtbarkeit.",
          signup_cta: "Registrieren Sie Ihr Unternehmen jetzt für nur 25 $ pro Jahr",

          whoShouldSignUp: "Wer sollte sich registrieren und warum?",
          twoTypesAccounts: "Wir bieten zwei Arten von Konten an.",
          businessAccountDescription: "Unsere globalen Unternehmensseiten sind auf kleine Unternehmen zugeschnitten, die eine breite Marketingreichweite und sofortige internationale Sichtbarkeit anstreben.",
          businessPageFeatures: "Unsere Unternehmensseiten listen Ihre Firmeninformationen wie Google Maps mit Kartenauffindbarkeit, aber auch mit dem zusätzlichen Vorteil von Gruppenchats, Direktnachrichten, sozialen Medienfunktionen und einer eigenen Pinnwand für Unternehmensbranding und Updates.",
          accountTypes: "Individuelle persönliche Konten, die kostenlos sind, und kostenpflichtige Geschäftskonten.",
          soldQuestion: "Okay, ich bin überzeugt – wie registriere ich mich?",
          signUpInstructions: "Sie können sich als kostenloser Benutzer oder als kostenpflichtiger Geschäftsnutzer auf unserer Registrierungsseite anmelden und im Dropdown-Menü den gewünschten Kontotyp auswählen.",
          step1: "Schritt 1",
          step2: "Schritt 2",
          step3: "Schritt 3",
          step4: "Schritt 4",
          done: "klaar",
          step1_desc: "Fülle die Firmendetails aus, füge die Unternehmenswebsite und ein Firmenprofilfoto hinzu.",
          step2_desc: "Aktivieren Sie, dass Ihr Browser den Standort mit iBouge ® teilt, damit wir Ihr Unternehmen dort markieren können, wo es sich befindet.",
          step3_desc: "Wählen Sie Ihre drei Lieblingsstädte aus, um Updates in Ihrem Newsfeed zu erhalten. Sie können diese Städte jederzeit ändern, um neue Orte zu erkunden.",
          step4_desc: "Gib deine Kreditkartendaten ein, um deine neue Mitgliedschaft über unseren sicheren Transaktionspartner Stripe zu beginnen.",
          enjoyBenefits: "und beginnen Sie, die Vorteile unserer Plattform zu genießen",
          done_steps: "Deine Unternehmensseite wird automatisch aktiviert und meldet sich dann auf der Plattform an.",

          profileUpdated: "Profil wurde aktualisiert",
          deactivateConfirm: "Bist du sicher, dass du das Konto deaktivieren möchtest?",
          enterTextOrImage: "Bitte Text eingeben oder Bild auswählen",
          fileTooBig: "Dateigröße ist zu groß",
          selectFileFirst: "Bitte zuerst eine Datei auswählen",
          waitForUpload: "Bitte warte, bis das Medium hochgeladen ist",
          alreadyExistInGroup: "Bereits in der Gruppe vorhanden",
          enterMsgFirst: "Nachricht zuerst eingeben",
          someFilesTooBig: "Einige Dateien waren zu groß und wurden nicht ausgewählt.",
          enterMessage: "Nachricht eingeben",
          enterNewPassword: "Bitte gib dein neues Passwort ein",

          contact_us: "Kontaktieren Sie uns",
          write_to_us: "Schreiben Sie uns",
          message_intro: "Wir würden uns freuen, von Ihnen zu hören! Bitte hinterlassen Sie uns eine Nachricht, wir melden uns bald.",
          your_name: "Ihr Name",
          subject: "Betreff",
          query: "Anfrage",
          send_message: "Nachricht senden",
          message: "Nachricht",
          submit: "Absenden",
          global_hq: "Weltweite Zentrale:",
          address: "Redmond, WA 98052, Vereinigte Staaten",
          hours: "Mo - Fr: 9:00-17:00 PST",

          mission_title: "Die Mission von iBouge",
          population_globe: "Bevölkerungs-Globus",
          expanding_world: "Erweitern Sie Ihre Welt",
          platform_intro: "Die patentierte Plattform von iBouge ermöglicht es Benutzern, Unternehmen, Personen und Informationen in jedem Land der Welt zu finden...",
          mission_statement: "Unsere Mission ist es, das offenste Informationsportal im Web für Menschen, Unternehmen und Gemeinschaften zu sein.",
          platform_use: "Mit iBouge können Sie weltweit Personen oder Unternehmen finden und verbinden, ohne ein Suchwort eingeben zu müssen...",
          shops_future: "Bald eröffnen wir Shops mit Produkten zum Verkauf auf unserer Plattform, sodass Sie nach Standort einkaufen können.",
          global_connect: "Die Welt ist globaler verbunden als je zuvor, und iBouge macht Ihre Informationen zentralisiert und offen...",
          fingertips: "Mit iBouge liegt die Welt in Ihren Händen.",

          press_statement: "Pressemitteilung",
          month: "MM",
          year: "JJJJ",
          search_article: "Artikel suchen",
          lisa_leslie: "Lisa Leslie",
          lisa_title: "Keine Grenzen: Wie Lisa Leslie die Welt ein wenig kleiner macht",
          lisa_updated: "Zuletzt aktualisiert am 07.05.2019",
          lisa_description: "Lisa Leslie entdeckte schon früh ihre Leidenschaft für Technologie. Sie spielte auf dem Familiencomputer und nutzte jede Gelegenheit, um im Internet zu experimentieren.",
          read_article: "Artikel lesen",
          card_cap: "Kartentitel",
          ibouge_title: "iBouge startet globale Geo-Networking-Plattform für Unternehmen",
          ibouge_updated: "Zuletzt aktualisiert am 07.05.2019",
          ibouge_now_description: "iBouge bietet jetzt Unternehmensseiten für Firmen weltweit an. Unternehmen können sich registrieren und sofort ein globales Publikum erreichen.",

          dashboard: "Mein Dashboard",
          mapOverview: "Kartenübersicht",
          businessProfile: "Unternehmensprofil",
          admin: "Admin",
          about: "Über uns",
          contact: "Kontakt",
          mission: "Mission",
          demo: "Demo",
          press: "Presse",
          blog: "Blog",
          privacy: "Datenschutz",
          terms: "Nutzungsbedingungen",

          typeToSearch: "Tippen zum Suchen",
          searching: "Suche...",
          account: "Konto",
          notifications: "Benachrichtigungen",
          inbox: "Posteingang",
          logout: "Abmelden",

          users: "Benutzer",
          events: "Veranstaltungen",
          microblogs: "Microblogs",
          business: "Geschäft",
          myProfile: "Mein Profil",

          globalNewsFeed: "Globale Neuigkeiten",
          whatsOnMind: "Was denkst du?",
          usePhoto: "Foto verwenden",
          close: "Schließen",
          usernameWall: "{{username}}s Pinnwand",
          noStatusUpdates: "Keine Statusaktualisierungen hier",
          typing: "Tippt",
          hidePostsInfo: "Das Verbergen von Beiträgen hilft iBouge, deine Inhalte zu personalisieren und zu verbessern",
          hidden: "Versteckt",
          post: "Beitrag",
          reportPost: "Beitrag melden",
          deletePost: "Beitrag löschen",
          writeComment: "Kommentar schreiben",
          deleteComment: "Kommentar löschen",
          addCommentText: "Bitte fügen Sie einen Text in den Kommentaren hinzu",
          noPosts: "Entschuldigung! Für diesen Standort sind noch keine Beiträge verfügbar. Bitte wähle einen anderen Standort.",
          startConversation: "Unterhaltung beginnen",
          friendsSelected: "Freund(e) ausgewählt",

          localEvents: "Lokale Veranstaltungen",
          myMicroblogs: "Meine Microblogs",
          edit: "Bearbeiten",
          addNew: "Neu hinzufügen",

          addCity: "Stadt hinzufügen",
          usernameConnection: "Verbindungen von {{username}}",
          selectOneFriend: "Bitte wähle mindestens einen Freund aus",
          createGroup: "Gruppe erstellen",
          noChats: "Keine Chats verfügbar",
          noNotifications: "Keine Benachrichtigungen",
          addNewEvent: "Neues Event hinzufügen",
          addNewMicroblog: "Neuen Microblog hinzufügen",
          addEvent: "Event hinzufügen",
          addMicroblog: "Microblog hinzufügen",

          signUp: "Registrieren",
          signIn: "Anmelden",
          login: "Anmelden",
          signupSteps: "Registrieren Sie sich in wenigen einfachen Schritten",
          welcomeLogin: "Willkommen! Melden Sie sich bei Ihrem Konto an",
          email: "E-Mail-Adresse",
          password: "Passwort",
          confirmPassword: "Passwort bestätigen",
          type: "Typ",
          personalAccount: "Persönliches Konto",
          businessAccount: "Geschäftskonto",
          firstName: "Vorname",
          lastName: "Nachname",
          gender: "Geschlecht",
          male: "Männlich",
          female: "Weiblich",
          preferNotSay: "Möchte ich nicht angeben",
          other: "Andere",
          continue: "Fortfahren",
          forgetPassword: "Passwort vergessen?",
          loginMyAccount: "In mein Konto einloggen",
          noAccount: "Noch kein Konto?",
          alreadyAccount: "Haben Sie bereits ein Konto?",

          businessCategory: "Geschäftskategorie",
          subscriptionType: "Abonnementtyp",
          selectPlan: "Wählen Sie einen Plan",
          freePlan: "Kostenloser Plan",
          premiumPlan: "Premium-Plan",
          businessName: "Firmenname",
          fillField: "Bitte füllen Sie das Feld aus, danke",
          loginVerified: "Bitte melden Sie sich nach der Verifizierung an",
          loginNewAccount: "Bitte melden Sie sich mit den Anmeldedaten Ihres neuen Kontos an",
          accountDisabled: "Ihr Konto wurde vom Administrator deaktiviert.",
          premiumOffer: "iBouge Premium bietet unbegrenzte Follower und priorisierte Suchergebnisse für Ihre Unternehmensseite.",

          enterOtp: "Bitte geben Sie das OTP ein, das an Ihre E-Mail gesendet wurde:",
          emailVerification: "E-Mail-Verifizierung",
          resendOtp: "OTP erneut senden",
          otpExpires: "OTP läuft in {{time}} Minuten ab",
          verify: "Verifizieren",
          restorePasswordText: "Geben Sie Ihre E-Mail-Adresse ein und wir helfen Ihnen weiter.",
          restorePassword: "Passwort wiederherstellen",
          createNewPassword: "Neues Passwort erstellen",
          back: "Zurück",
          patentNumbers: "Patentnummern",
          copyright: "Urheberrecht",
          allRightsReserved: "Alle Rechte vorbehalten",

          setup_stepOne: "Einrichtung 1/3",
          setup_profile: "Richten Sie Ihr Profil ein",
          about_me: "Über mich",
          about_me_placeholder: "Erzählen Sie uns ein wenig über sich",
          my_interests: "Meine Interessen",
          add_interests: "Interessen hinzufügen",
          my_languages: "Meine Sprachen",
          add_languages: "Sprachen hinzufügen",

          setup_stepTwo: "Einrichtung 2/3",
          setup_location: "Richten Sie Ihren Standort ein",
          add_your_location: "Fügen Sie Ihren Standort hinzu: Klicken Sie auf die Karte",
          enable_location: "Bitte aktivieren Sie den Standort in Ihrem Browser, um Sie in Ihrer Postleitzahl zu markieren.",
          tag_neighborhood: "Bitte markieren Sie sich in Ihrer Nachbarschaft, um die besten Community-Informationen zu erhalten und Menschen in Ihrer Nähe zu finden.",
          location_access: "Wir benötigen Zugriff auf den Standort Ihres Geräts, um maßgeschneiderte Empfehlungen, relevante Inhalte und verbesserte Funktionen bereitzustellen. Ihr Standort wird nur abgerufen, während die App geöffnet und in Gebrauch ist.",

          setup_stepThree: "EinThreehtung 3/3",
          select_cities: "Wählen Sie 3 Städte aus, um Community-Nachrichten und Updates zu erhalten",
          first_city: "Erste Stadt",
          search: "Suchen",
          second_city: "Zweite Stadt",
          third_city: "Dritte Stadt",
          selectFirstCity: "Bitte wählen Sie zuerst eine Stadt",
          enterOneCity: "Bitte geben Sie zuerst mindestens eine Stadt ein",

          step_oneFour: "Einrichtung 1/4",
          businessSummary: "Unternehmensübersicht",
          businessSummary_placeholder: "Erzählen Sie uns ein wenig über Ihr Unternehmen",
          businessContact: "Geschäftskontakt",
          companyWebsite: "Firmenwebsite eingeben",
          businessOffers: "Was bietet Ihr Unternehmen an?",
          addProduct: "Produkt oder Dienstleistung hinzufügen",

          agreeTerms: "Ich habe die Allgemeinen Geschäftsbedingungen gelesen, verstanden und stimme ihnen zu.",
          agreePrivacy: "Ich habe die Datenschutzrichtlinie gelesen, verstanden und stimme ihr zu.",
          continuePrivacy: "Weiter zur Datenschutzrichtlinie",
          continuePayment: "Weiter zur Zahlungsseite",
          createBusinessAccount: "Mein kostenloses iBouge-Geschäftskonto erstellen",
          createPersonalAccount: "Mein kostenloses iBouge-Persönlicheskonto erstellen",
          activateMembership: "Mitgliedschaft aktivieren",
          planName: "Planname",
          planType: "Plantyp",
          planPrice: "Planpreis",
          activateBusinessPage: "Meine iBouge-Geschäftsseite aktivieren",

          summary: "Zusammenfassung",
          interests: "Interessen",
          languages: "Sprachen",
          businessOffer: "Geschäftsangebot",
          openingHours: "Öffnungszeiten",
          timeZone: "Zeitzone",
          aboutBusiness: "Über das Geschäft",
          websiteUrl: "Webseite-URL",
          imageGallery: "Bildergalerie",
          noImage: "Keine Bilder in der Galerie gefunden",
          addMore: "Mehr hinzufügen",
          usernameFollowing: "{{username}} folgt",
          usernameFollowers: "Follower von {{username}}",
          shareProfile: "Profil teilen",
          editCoverPhoto: "Titelbild bearbeiten",
          urlCopied: "URL in die Zwischenablage kopiert",

          upload: "Hochladen",
          uploading: "Wird hochgeladen",
          postDeleted: "Dieser Beitrag wurde gelöscht",
          activatePremium: "Premium-Plan aktivieren",
          sharePress: "Beitrag teilen",
          seen: "Gesehen",
          deletePicture: "Bild löschen",
          savePicture: "Bild speichern",
          sharePicture: "Bild teilen",
          makeCoverPicture: "Als Titelbild festlegen",
          makeProfilePicture: "Als Profilbild festlegen",
          copyURL: "URL kopieren",
          closed: "Geschlossen",
          notSet: "Nicht festgelegt",
          thankYou: "Danke!",
          loggingIntoIBouge: "Du wirst in iBouge eingeloggt in",
          businessActivated: "Danke! Deine Unternehmensseite wurde aktiviert.",
          shareTo: "Teilen mit",
          stepFourOfFour: "Schritt 4/4",

          step_OneTwo: "Schritt 1/2",
          event_details: "Veranstaltungsdetails",
          event_name: "Veranstaltungsname",
          sample_event: "Größte Pizza-Challenge 2022",
          event_category: "Veranstaltungskategorie",
          start_date: "Startdatum",
          date_format: "TT/MM/JJJJ",
          start_time: "Startzeit",
          end_time: "Endzeit",
          event_description: "Veranstaltungsbeschreibung",
          cover_photo: "Titelbild",
          next_to_location: "Weiter zur Location",
          step_TwoTwo: "Schritt 2/2",
          enter_location: "Standortdetails eingeben",
          add_event_details: "Ereignisdetails hinzufügen: Auf die Karte klicken",
          create_event: "Ereignis erstellen",
          users_interested: "Benutzer sind interessiert",
          going: "GEHT",
          not_going: "NICHT TEILNEHMEN",
          invite: "Einladen",
          inviteUsers: "Benutzer einladen",
          typeToInvite: "Hier tippen, um Benutzer einzuladen",
          friendsGoing: "{{number}} deiner Freunde gehen.",
          usersInterested: "{{number}} Benutzer sind interessiert",
          bookmark: "Merken",
          bookmarked: "Gespeichert",

          microblog_name: "Microblog-Name",
          add_location: "Standort hinzufügen: Auf die Karte klicken",
          search_address: "Adresse suchen",
          create: "Erstellen",
          public: "Öffentlich",
          private: "Privat",
          searchAddress: "Bitte nach einer Adresse suchen",
          selectImage: "Bitte das Bild auswählen",

          general: "Allgemein",
          location: "Standort",
          payments: "Zahlungen",

          companyWebsiteUrl: "Unternehmenswebsite-URL",
          settings: "Einstellungen",
          wall_private: "Meine Pinnwand nur für Freunde sichtbar machen",
          profile_private: "Mein Profil nur für meine Freunde privat machen",
          friends_list_private: "Meine Freundesliste nur meinen Freunden zeigen",
          anyone_follow: "Jeder kann mir folgen",
          accept_messages: "Ich akzeptiere neue Nachrichten von außerhalb meiner Freundesgruppe",
          block_list: "Blockierliste",
          block_users: "Benutzer blockieren",
          type_to_name: "Namen eingeben",
          block_list_empty: "Blockierliste ist leer",

          wall_notifications: "Pinnwand-Benachrichtigungen",
          event_invitations: "Einladungen zu Veranstaltungen",
          friend_requests: "Freundschaftsanfragen-Benachrichtigungen",
          message_notifications: "Nachrichten-Benachrichtigungen",
          deactivateAccount: "Konto deaktivieren",
          deleteAccount: "Konto löschen",
          cancel: "Abbrechen",
          save: "Speichern",

          topCities: "Top-Städte",
          chooseLocations: "Wähle bis zu drei Orte aus, denen du folgen möchtest. Wähle eine Stadt, um zu einer neuen zu wechseln",
          city1: "Stadt 1",
          city2: "Stadt 2",
          city3: "Stadt 3",
          searchCity: "Nach einer Stadt suchen",

          flagContent: "Anstößigen Inhalt melden",
          selectReportType: "Berichtstyp auswählen",
          unhidePost: "Beitrag einblenden",
          hidePost: "Beitrag ausblenden",
          cancelSubscription: "Abonnement kündigen",
          accountUpdated: "Konto wurde aktualisiert",
          subscriptionAmount: "Abonnementbetrag",
          subscriptionStartDate: "Startdatum des Abonnements",
          subscriptionEndDate: "Enddatum des Abonnements",
          locationUpdated: "Standort wurde aktualisiert",
          notificationsUpdated: "Benachrichtigungen wurden aktualisiert",
          privacyUpdated: "Datenschutzeinstellungen wurden aktualisiert",
          undo: "Rückgängig",
          block: "Blockieren",
          unblock: "Entsperren",
          confirm: "Bestätigen",
          activateAccount: "Konto aktivieren",
          accountDeactivated: "Hoppla! Dein Konto ist derzeit deaktiviert",
          confirmDeleteAccount: "Bist du sicher, dass du das Konto löschen möchtest?",
          confirmActivateAccount: "Bist du sicher, dass du das Konto aktivieren möchtest?",

          delivered: "Zugestellt",
          download: "Herunterladen",
          noChatFound: "Kein Chat gefunden",
          messageSeenBy: "Nachricht gesehen von folgendem Benutzer",
          othersCount: "+ {{number}} weitere",
          notSelectedYet: "Noch nicht ausgewählt",
          nameTyping: "{{name}} schreibt...",
          twoTyping: "{{name1}} und {{name2}} schreiben...",
          multipleTyping: "{{name1}} und {{number}} weitere schreiben...",
          wallPrivate: "Diese Pinnwand ist privat",
          profileHidden: "Dieses Benutzerprofil ist verborgen",
          profilePrivate: "Dieses Benutzerprofil ist privat",
          follow: "Folgen",
          following: "Folgt",
          and: "und",
          others: "{{number}} weitere",
          acceptFriendRequest: "Freundschaftsanfrage annehmen",
          friendRequestSent: "Freundschaftsanfrage gesendet",
          friends: "Freunde",
          confirmUnfollow: "Bist du sicher, dass du nicht mehr folgen möchtest?",
          confirmUnfriend: "Bist du sicher, dass du die Freundschaft beenden möchtest?",
          upgradeMessage: "Bitte upgrade auf unseren Premium-Plan, um unbegrenzte Follower auf deiner Unternehmensseite freizuschalten.",
          upgrade: "Upgrade",

          noConnectionsFound: "Keine Verbindungen gefunden",
          followersPrivate: "Die Follower-Liste dieses Benutzers ist privat",
          friendsPrivate: "Die Freundesliste dieses Benutzers ist privat",
          addAsFriend: "Als Freund hinzufügen",
          add: "Hinzufügen",
          unfriend: "Freund entfernen",
          unfollow: "ontvolgen",
          chat: "Chat",
          inviteToChat: "Zum Chat einladen",
        }
      },
      it: {
        translation: {

          introducing: "Presentazione di iBouge",
          whatIsIBouge: "Che cos'è iBouge<0>®</0>?",
          ibougeIntro: "iBouge è una piattaforma di mappatura che colloca persone, prodotti e informazioni su un'interfaccia di mappa globale per renderli più accessibili e facili da trovare dalla popolazione mondiale di Internet, consentendo loro di interagire in nuovi modi.",
          ibougeDescription: "La nostra interfaccia di mappa globale brevettata e unica categorizza i contenuti in un modo nuovo e consente alle persone di essere trovate e ai contenuti di essere visualizzati su scala globale. Gli utenti di iBouge ® possono connettersi con chiunque nel mondo e le aziende possono raggiungere qualsiasi pubblico ovunque si trovino.",
          sign_up: "Registrati",
          howDoISignUp: "Ok, mi hai convinto,<1/><0>come mi iscrivo?</0>",
          products_intro: "Attualmente offriamo 4 prodotti sulla nostra interfaccia di mappa:",
          product1: "Incontrare persone nelle vicinanze",
          product2: "Pagine aziendali globali",
          product3: "Chat basate su mappe su punti di interesse",
          product4: "Eventi locali fissati sulla nostra mappa e trasmessi a chiunque segua quell'area.",
          whatDifferentiates: "<0>Cosa differenzia la piattaforma </0>da altre aziende di social media?",
          business_price: "Le nostre pagine aziendali costano solo 25 $ l'anno con visibilità globale.",
          signup_cta: "Registra subito la tua attività per soli 25 $ all'anno",

          whoShouldSignUp: "Chi dovrebbe registrarsi per un account e perché?",
          twoTypesAccounts: "Offriamo due tipi di account.",
          businessAccountDescription: "Le nostre pagine aziendali globali sono pensate per le piccole imprese che cercano un'ampia esposizione di marketing e visibilità internazionale immediata.",
          businessPageFeatures: "Le nostre pagine aziendali elencano le informazioni della tua azienda come Google Maps, con la possibilità di essere trovate sulla mappa, ma con il vantaggio aggiuntivo di chat di gruppo, messaggistica diretta, funzionalità di social media e un muro personale per il branding e gli aggiornamenti aziendali.",
          accountTypes: "Account personali individuali gratuiti e account aziendali a pagamento.",
          soldQuestion: "Ok, mi hai convinto, come mi registro?",
          signUpInstructions: "Puoi registrarti come utente gratuito o come utente aziendale a pagamento sulla nostra pagina di registrazione e selezionare il tipo di account che preferisci dal menu a discesa Tipo di account.",
          step1: "Passaggio 1",
          step2: "Passaggio 2",
          step3: "Passaggio 3",
          step4: "Passaggio 4",
          done: "fatto",
          step1_desc: "Compila i dettagli dell'azienda, aggiungi il sito web e una foto del profilo aziendale.",
          step2_desc: "Abilita il tuo browser a condividere la posizione con iBouge ® in modo che possiamo contrassegnare la tua attività dove si trova.",
          step3_desc: "Seleziona le tue 3 città preferite da seguire per aggiornamenti nel tuo feed di notizie. Puoi modificare queste città in qualsiasi momento per esplorare nuovi luoghi.",
          step4_desc: "Compila i dettagli della carta di credito per iniziare la tua nuova iscrizione utilizzando il nostro partner di transazioni sicure Stripe.",
          enjoyBenefits: "e inizia a godere dei vantaggi della nostra piattaforma",
          done_steps: "La tua pagina aziendale si attiverà automaticamente e poi accederà alla piattaforma.",

          profileUpdated: "Il profilo è stato aggiornato",
          deactivateConfirm: "Sei sicuro di voler disattivare l'account?",
          enterTextOrImage: "Per favore inserisci del testo o seleziona un'immagine",
          fileTooBig: "La dimensione del file è troppo grande",
          selectFileFirst: "Seleziona prima un file",
          waitForUpload: "Attendi il caricamento dei media",
          alreadyExistInGroup: "Esiste già nel gruppo",
          enterMsgFirst: "Inserisci prima un messaggio",
          someFilesTooBig: "Alcuni file erano troppo grandi e non sono stati selezionati.",
          enterMessage: "Inserisci messaggio",
          enterNewPassword: "Inserisci la tua nuova password",

          contact_us: "Contattaci",
          write_to_us: "Scrivici",
          message_intro: "Ci farebbe piacere sentirti! Lasciaci un messaggio e ti contatteremo presto.",
          your_name: "Il Tuo Nome",
          subject: "Oggetto",
          query: "Richiesta",
          send_message: "Invia Messaggio",
          message: "Messaggio",
          submit: "Invia",
          global_hq: "Sede Globale:",
          address: "Redmond, WA 98052, Stati Uniti",
          hours: "Lun - Ven: 9:00-17:00 PST",

          mission_title: "La Missione di iBouge",
          population_globe: "Globo della Popolazione",
          expanding_world: "Espandere il tuo mondo",
          platform_intro: "La piattaforma brevettata di iBouge consente agli utenti di trovare aziende, persone e informazioni in qualsiasi paese del mondo...",
          mission_statement: "La nostra missione è essere il portale di informazioni più aperto sul web per persone, aziende e comunità.",
          platform_use: "Con iBouge puoi trovare e connetterti con qualsiasi persona al mondo o qualsiasi azienda senza digitare parole chiave...",
          shops_future: "Presto apriremo negozi con prodotti in vendita sulla nostra piattaforma in modo da poter acquistare per località.",
          global_connect: "Il mondo è più connesso che mai e iBouge è progettato per rendere le tue informazioni centralizzate e aperte...",
          fingertips: "Con iBouge, il mondo è a portata di mano.",

          press_statement: "Comunicato stampa",
          month: "MM",
          year: "AAAA",
          search_article: "Cerca articolo",
          lisa_leslie: "Lisa Leslie",
          lisa_title: "Senza confini: Come Lisa Leslie sta rendendo il mondo un po' più piccolo",
          lisa_updated: "Ultimo aggiornamento 07/05/2019",
          lisa_description: "Lisa Leslie si è appassionata alla tecnologia fin da giovane. È cresciuta giocando al computer di famiglia e sperimentando sul Web.",
          read_article: "Leggi articolo",
          card_cap: "Intestazione scheda",
          ibouge_title: "iBouge lancia piattaforma globale di geo-networking per le aziende",
          ibouge_updated: "Ultimo aggiornamento 07/05/2019",
          ibouge_now_description: "iBouge ora offre pagine aziendali per imprese in tutto il mondo. Le aziende possono registrarsi e raggiungere istantaneamente un pubblico globale.",

          dashboard: "La Mia Dashboard",
          mapOverview: "Panoramica Mappa",
          businessProfile: "Profilo Aziendale",
          admin: "Admin",
          about: "Chi siamo",
          contact: "Contatto",
          mission: "Missione",
          demo: "Demo",
          press: "Stampa",
          blog: "Blog",
          privacy: "Privacy",
          terms: "Termini di servizio",

          typeToSearch: "Digita per cercare",
          searching: "Ricerca...",
          account: "Account",
          notifications: "Notifiche",
          inbox: "Posta in arrivo",
          logout: "Disconnettersi",

          users: "Utenti",
          events: "Eventi",
          microblogs: "Microblog",
          business: "Impresa",
          myProfile: "Il mio profilo",

          globalNewsFeed: "Notizie globali",
          whatsOnMind: "A cosa stai pensando?",
          usePhoto: "Usa foto",
          close: "Chiudi",
          usernameWall: "Bacheca di {{username}}",
          noStatusUpdates: "Nessun aggiornamento di stato qui",
          typing: "Sta scrivendo",
          hidePostsInfo: "Nascondere i post aiuta iBouge a personalizzare e migliorare i tuoi contenuti",
          hidden: "Nascosto",
          post: "Pubblica",
          reportPost: "Segnala post",
          deletePost: "Elimina post",
          writeComment: "Scrivi un commento",
          deleteComment: "Elimina commento",
          addCommentText: "Per favore aggiungi del testo nei commenti",
          noPosts: "Spiacente! Nessun post disponibile per questa posizione. Prova un'altra posizione.",
          startConversation: "Avvia conversazione",
          friendsSelected: "Amico/i selezionato/i",

          localEvents: "Eventi locali",
          myMicroblogs: "I miei microblog",
          edit: "Modifica",
          addNew: "Aggiungi nuovo",

          addCity: "Aggiungi città",
          usernameConnection: "Connessioni di {{username}}",
          selectOneFriend: "Seleziona almeno un amico",
          createGroup: "Crea gruppo",
          noChats: "Nessuna chat disponibile",
          noNotifications: "Nessuna notifica",
          addNewEvent: "Aggiungi nuovo evento",
          addNewMicroblog: "Aggiungi nuovo microblog",
          addEvent: "Aggiungi evento",
          addMicroblog: "Aggiungi microblog",

          signUp: "Iscriviti",
          signIn: "Accedi",
          login: "Accedi",
          signupSteps: "Iscriviti in pochi semplici passaggi",
          welcomeLogin: "Benvenuto! Accedi al tuo account",
          email: "Indirizzo email",
          password: "Password",
          confirmPassword: "Conferma password",
          type: "Tipo",
          personalAccount: "Account personale",
          businessAccount: "Account aziendale",
          firstName: "Nome",
          lastName: "Cognome",
          gender: "Genere",
          male: "Maschio",
          female: "Femmina",
          preferNotSay: "Preferisco non dirlo",
          other: "Altro",
          continue: "Continua",
          forgetPassword: "Password dimenticata?",
          loginMyAccount: "Accedi al mio account",
          noAccount: "Non hai un account?",
          alreadyAccount: "Hai già un account?",

          businessCategory: "Categoria aziendale",
          subscriptionType: "Tipo di abbonamento",
          selectPlan: "Seleziona un piano",
          freePlan: "Piano gratuito",
          premiumPlan: "Piano premium",
          businessName: "Nome azienda",
          fillField: "Si prega di compilare il campo, grazie",
          loginVerified: "Effettua l’accesso dopo essere stato verificato",
          loginNewAccount: "Accedi con le credenziali del tuo nuovo account",
          accountDisabled: "Il tuo account è stato disabilitato dall'amministratore.",
          premiumOffer: "iBouge Premium offre follower illimitati e risultati di ricerca prioritari per la tua pagina aziendale.",

          enterOtp: "Inserisci l'OTP inviato all'email:",
          emailVerification: "Verifica email",
          resendOtp: "Reinvia OTP",
          otpExpires: "L'OTP scade tra {{time}} minuti",
          verify: "Verifica",
          restorePasswordText: "Inserisci il tuo indirizzo email e ti rimetteremo in carreggiata.",
          restorePassword: "Ripristina la password",
          createNewPassword: "Crea nuova password",
          back: "Indietro",
          patentNumbers: "Numeri di brevetto",
          copyright: "Copyright",
          allRightsReserved: "Tutti i diritti riservati",

          setup_stepOne: "Configurazione 1/3",
          setup_profile: "Imposta il tuo profilo",
          about_me: "Su di me",
          about_me_placeholder: "Raccontaci un po' di te",
          my_interests: "I miei interessi",
          add_interests: "Aggiungi interessi",
          my_languages: "Le mie lingue",
          add_languages: "Aggiungi lingue",

          setup_stepTwo: "Impostazione 2/3",
          setup_location: "Imposta la tua posizione",
          add_your_location: "Aggiungi la tua posizione: Clicca sulla mappa",
          enable_location: "Abilita la posizione del tuo browser per etichettarti nel tuo CAP.",
          tag_neighborhood: "Per favore, segnati nel tuo quartiere per ricevere le migliori informazioni della comunità e trovare persone intorno a te.",
          location_access: "Abbiamo bisogno di accedere alla posizione del tuo dispositivo per fornire raccomandazioni personalizzate, contenuti rilevanti e funzionalità migliorate. La tua posizione è accessibile solo mentre l'app è aperta e in uso.",

          setup_stepThree: "ConfigThreezione 3/3",
          select_cities: "Seleziona 3 città da seguire per notizie e aggiornamenti della comunità",
          first_city: "Prima Città",
          search: "Cerca",
          second_city: "Seconda Città",
          third_city: "Terza Città",
          selectFirstCity: "Seleziona prima una città",
          enterOneCity: "Inserisci almeno una città prima",

          step_oneFour: "Configurazione 1/4",
          businessSummary: "Riepilogo aziendale",
          businessSummary_placeholder: "Raccontaci un po' della tua attività",
          businessContact: "Contatto aziendale",
          companyWebsite: "Inserisci il sito web aziendale",
          businessOffers: "Cosa offre la tua azienda?",
          addProduct: "Aggiungi prodotto o servizio",

          agreeTerms: "Ho letto, compreso e accetto i Termini e Condizioni.",
          agreePrivacy: "Ho letto, compreso e accetto l'Informativa sulla Privacy.",
          continuePrivacy: "Continua all'Informativa sulla Privacy",
          continuePayment: "Continua alla pagina di pagamento",
          createBusinessAccount: "Crea il mio account iBouge business gratuito",
          createPersonalAccount: "Crea il mio account iBouge personale gratuito",
          activateMembership: "Attiva abbonamento",
          planName: "Nome del piano",
          planType: "Tipo di piano",
          planPrice: "Prezzo del piano",
          activateBusinessPage: "Attiva la mia pagina business iBouge",

          summary: "Riepilogo",
          interests: "Interessi",
          languages: "Lingue",
          businessOffer: "Offerta commerciale",
          openingHours: "Orari di apertura",
          timeZone: "Fuso orario",
          aboutBusiness: "Informazioni sull'attività",
          websiteUrl: "URL del sito web",
          imageGallery: "Galleria di immagini",
          noImage: "Nessuna immagine trovata nella galleria",
          addMore: "Aggiungi altro",
          usernameFollowing: "{{username}} sta seguendo",
          usernameFollowers: "Follower di {{username}}",
          shareProfile: "Condividi profilo",
          editCoverPhoto: "Modifica foto di copertina",
          urlCopied: "URL copiato negli appunti",

          upload: "Carica",
          uploading: "Caricamento in corso",
          postDeleted: "Questo post è stato eliminato",
          activatePremium: "Attiva piano premium",
          sharePress: "Condividi post",
          seen: "Visto",
          deletePicture: "Elimina immagine",
          savePicture: "Salva immagine",
          sharePicture: "Condividi immagine",
          makeCoverPicture: "Imposta come immagine di copertina",
          makeProfilePicture: "Imposta come immagine del profilo",
          copyURL: "Copia URL",
          closed: "Chiuso",
          notSet: "Non impostato",
          thankYou: "Grazie!",
          loggingIntoIBouge: "Accesso a iBouge tra",
          businessActivated: "Grazie! La tua pagina aziendale è stata attivata.",
          shareTo: "Condividi su",
          stepFourOfFour: "Passaggio 4/4",

          step_OneTwo: "Fase 1/2",
          event_details: "Dettagli dell'Evento",
          event_name: "Nome dell'Evento",
          sample_event: "La Sfida della Pizza Più Grande 2022",
          event_category: "Categoria dell'Evento",
          start_date: "Data di Inizio",
          date_format: "gg/mm/aaaa",
          start_time: "Ora di Inizio",
          end_time: "Ora di Fine",
          event_description: "Descrizione dell'Evento",
          cover_photo: "Foto di Copertina",
          next_to_location: "Avanti alla Posizione",
          step_TwoTwo: "Passo 2/2",
          enter_location: "Inserisci i Dettagli della Posizione",
          add_event_details: "Aggiungi i dettagli dell'evento: Clicca sulla mappa",
          create_event: "Crea Evento",
          users_interested: "Utenti interessati",
          going: "PARTECIPA",
          not_going: "NON PARTECIPA",
          invite: "Invita",
          inviteUsers: "Invita utenti",
          typeToInvite: "Scrivi qui per invitare un utente",
          friendsGoing: "{{number}} dei tuoi amici parteciperanno.",
          usersInterested: "{{number}} utenti sono interessati",
          bookmark: "Salva",
          bookmarked: "Aggiunto ai preferiti",

          microblog_name: "Nome del Microblog",
          add_location: "Aggiungi posizione: Clicca sulla mappa",
          search_address: "Cerca un indirizzo",
          create: "Crea",
          public: "Pubblico",
          private: "Privato",
          searchAddress: "Cerca un indirizzo",
          selectImage: "Seleziona l'immagine",

          general: "Generale",
          location: "Posizione",
          payments: "Pagamenti",

          companyWebsiteUrl: "URL del sito web aziendale",
          settings: "Impostazioni",
          wall_private: "Rendi il mio muro visibile solo agli amici",
          profile_private: "Rendi il mio profilo privato solo per i miei amici",
          friends_list_private: "Mostra la mia lista di amici solo ai miei amici",
          anyone_follow: "Chiunque può seguirmi",
          accept_messages: "Accetto nuovi messaggi al di fuori del mio gruppo di amici",
          block_list: "Lista Bloccati",
          block_users: "Blocca Utenti",
          type_to_name: "Digita un nome",
          block_list_empty: "La lista dei bloccati è vuota",

          wall_notifications: "Notifiche sulla bacheca",
          event_invitations: "Inviti a eventi",
          friend_requests: "Notifiche di richieste di amicizia",
          message_notifications: "Notifiche di messaggi",
          deactivateAccount: "Disattiva account",
          deleteAccount: "Elimina account",
          cancel: "Annulla",
          save: "Salva",

          topCities: "Città principali",
          chooseLocations: "Scegli fino a tre località da seguire per gli aggiornamenti. Seleziona una città per passare a una nuova",
          city1: "Città 1",
          city2: "Città 2",
          city3: "Città 3",
          searchCity: "Cerca una città",

          flagContent: "Segnala contenuto offensivo",
          selectReportType: "Seleziona il tipo di segnalazione",
          unhidePost: "Mostra post",
          hidePost: "Nascondi post",
          cancelSubscription: "Annulla abbonamento",
          accountUpdated: "L'account è stato aggiornato",
          subscriptionAmount: "Importo dell'abbonamento",
          subscriptionStartDate: "Data di inizio dell'abbonamento",
          subscriptionEndDate: "Data di fine dell'abbonamento",
          locationUpdated: "La posizione è stata aggiornata",
          notificationsUpdated: "Le notifiche sono state aggiornate",
          privacyUpdated: "La privacy è stata aggiornata",
          undo: "Annulla",
          block: "Blocca",
          unblock: "Sblocca",
          confirm: "Conferma",
          activateAccount: "Attiva account",
          accountDeactivated: "Ops! Il tuo account è attualmente disattivato",
          confirmDeleteAccount: "Sei sicuro di voler eliminare l'account?",
          confirmActivateAccount: "Sei sicuro di voler attivare l'account?",

          delivered: "Consegnato",
          download: "Scarica",
          noChatFound: "Nessuna chat trovata",
          messageSeenBy: "Messaggio visto dal seguente utente",
          othersCount: "+ {{number}} altri",
          notSelectedYet: "Non ancora selezionato",
          nameTyping: "{{name}} sta scrivendo...",
          twoTyping: "{{name1}} e {{name2}} stanno scrivendo...",
          multipleTyping: "{{name1}} e altri {{number}} stanno scrivendo...",
          wallPrivate: "Questo muro è privato",
          profileHidden: "Il profilo di questo utente è nascosto",
          profilePrivate: "Il profilo di questo utente è privato",
          follow: "Segui",
          following: "Seguito",
          and: "e",
          others: "{{number}} altri",
          acceptFriendRequest: "Accetta richiesta di amicizia",
          friendRequestSent: "Richiesta di amicizia inviata",
          friends: "Amici",
          confirmUnfollow: "Sei sicuro di voler smettere di seguire?",
          confirmUnfriend: "Sei sicuro di voler rimuovere l’amico?",
          upgradeMessage: "Aggiorna al nostro piano premium per sbloccare follower illimitati sulla tua pagina aziendale.",
          upgrade: "Aggiorna",

          noConnectionsFound: "Nessuna connessione trovata",
          followersPrivate: "L'elenco dei follower di questo utente è privato",
          friendsPrivate: "L'elenco degli amici di questo utente è privato",
          addAsFriend: "Aggiungi come amico",
          add: "Aggiungi",
          unfriend: "Rimuovi amico",
          unfollow: "seguire",
          chat: "Chat",
          inviteToChat: "Invita alla chat",
        }
      },
      pt: {
        translation: {

          introducing: "Apresentando o iBouge",
          whatIsIBouge: "O que é o iBouge<0>®</0>?",
          ibougeIntro: "O iBouge é uma plataforma de mapeamento que coloca pessoas, produtos e informações em uma interface de mapa global para torná-los mais acessíveis e fáceis de encontrar pela população global da internet, permitindo novas formas de interação.",
          ibougeDescription: "Nossa interface de mapa global patenteada e exclusiva categoriza o conteúdo de uma nova maneira e permite que as pessoas sejam encontradas e o conteúdo seja visto em escala global. Os usuários do iBouge® podem se conectar com qualquer pessoa no mundo, e as empresas podem alcançar qualquer público em qualquer lugar do globo, independentemente de onde estejam localizadas.",
          sign_up: "Registrar-se",
          howDoISignUp: "Ok, estou convencido,<1/><0>como faço para me registrar?</0>",
          products_intro: "Atualmente, oferecemos 4 produtos em nossa interface de mapa:",
          product1: "Conhecer pessoas próximas",
          product2: "Páginas empresariais globais",
          product3: "Conversas baseadas em mapa sobre pontos de interesse",
          product4: "Eventos locais fixados em nosso mapa e transmitidos para todos que seguem essa área.",
          whatDifferentiates: "<0>O que diferencia a plataforma </0>de outras redes sociais?",
          business_price: "Nossas páginas empresariais custam apenas 25 dólares por ano com visibilidade global.",
          signup_cta: "Cadastre agora a sua empresa por apenas 25 dólares por ano",

          whoShouldSignUp: "Quem deve se registrar e por quê?",
          twoTypesAccounts: "Oferecemos dois tipos de contas.",
          businessAccountDescription: "Nossas páginas empresariais globais são voltadas para pequenas empresas que buscam ampla exposição de marketing e visibilidade internacional imediata.",
          businessPageFeatures: "Nossas páginas empresariais listam as informações da sua empresa como no Google Maps, com capacidade de localização no mapa e ainda com os benefícios adicionais de chat em grupo, mensagens diretas, recursos de rede social e um mural pessoal para a marca e atualizações da sua empresa.",
          accountTypes: "Contas pessoais individuais, que são gratuitas, e contas empresariais pagas.",
          soldQuestion: "Ok, estou convencido, como faço para me registrar?",
          signUpInstructions: "Você pode se registrar como usuário gratuito ou como usuário empresarial pago em nossa página de registro, selecionando o tipo de conta desejado no menu suspenso Tipo de Conta.",
          step1: "Etapa 1",
          step2: "Etapa 2",
          step3: "Etapa 3",
          step4: "Etapa 4",
          done: "Concluído",
          step1_desc: "Preencha os detalhes da empresa, adicione o site e uma foto de perfil da empresa.",
          step2_desc: "Permita que seu navegador compartilhe sua localização com o iBouge® para que possamos marcar o local da sua empresa.",
          step3_desc: "Selecione suas 3 cidades favoritas para seguir e receber atualizações no seu feed de notícias. Você pode alterá-las a qualquer momento para explorar novos lugares.",
          step4_desc: "Preencha os dados do seu cartão de crédito para iniciar sua nova assinatura usando nosso parceiro de transações seguras, Stripe.",
          enjoyBenefits: "e comece a desfrutar dos benefícios de usar nossa plataforma",
          done_steps: "Sua página empresarial será ativada automaticamente e, em seguida, você poderá entrar na plataforma.",

          profileUpdated: "Perfil atualizado",
          deactivateConfirm: "Tem certeza de que deseja desativar a conta?",
          enterTextOrImage: "Por favor, insira um texto ou selecione uma imagem",
          fileTooBig: "O tamanho do arquivo é muito grande",
          selectFileFirst: "Por favor, selecione um arquivo primeiro",
          waitForUpload: "Por favor, aguarde o upload da mídia",
          alreadyExistInGroup: "Já existe no grupo",
          enterMsgFirst: "Digite uma mensagem primeiro",
          someFilesTooBig: "Alguns arquivos eram muito grandes e não foram selecionados.",
          enterMessage: "Digite a mensagem",
          enterNewPassword: "Por favor, insira sua nova senha",

          contact_us: "Fale Conosco",
          write_to_us: "Escreva para nós",
          message_intro: "Adoraríamos ouvir você! Por favor, deixe-nos uma mensagem e entraremos em contato em breve.",
          your_name: "Seu Nome",
          subject: "Assunto",
          query: "Dúvida",
          send_message: "Enviar Mensagem",
          message: "Mensagem",
          submit: "Enviar",
          global_hq: "Sede Global:",
          address: "Redmond, WA 98052, Estados Unidos",
          hours: "Seg - Sex: 9:00-17:00 PST",

          mission_title: "Missão do iBouge",
          population_globe: "Globo Populacional",
          expanding_world: "Expandindo o seu mundo",
          platform_intro: "A plataforma patenteada do iBouge permite que os usuários encontrem empresas, pessoas e informações de qualquer país do mundo. Nossos mapas criam uma plataforma universal e aberta para buscar empresas, conectar-se a novas pessoas e interagir com comunidades que importam para você.",
          mission_statement: "Nossa missão é ser o portal de informações mais aberto da web para pessoas, empresas e comunidades.",
          platform_use: "Com o iBouge, você pode encontrar e se conectar com qualquer pessoa no mundo ou localizar qualquer empresa globalmente sem digitar uma busca por palavra-chave. Basta clicar no mapa e ampliar para encontrar empresas em locais de seu interesse ou pessoas que você gostaria de conhecer.",
          shops_future: "Em breve abriremos lojas com produtos à venda em nossa plataforma, permitindo que você compre por localização.",
          global_connect: "O mundo está mais conectado globalmente do que nunca, e o iBouge é projetado para tornar suas informações centralizadas e abertas, sem limites sobre onde comprar, com quem se conectar ou com quais comunidades interagir.",
          fingertips: "Com o iBouge, o mundo está ao seu alcance.",

          press_statement: "Comunicado à Imprensa",
          month: "MM",
          year: "AAAA",
          search_article: "Pesquisar Artigo",
          lisa_leslie: "Lisa Leslie",
          lisa_title: "Sem Fronteiras: Como Lisa Leslie Está Tornando o Mundo um Pouco Menor",
          lisa_updated: "Última atualização: 07/05/2019",
          lisa_description: "Lisa Leslie se interessou por tecnologia desde cedo. Cresceu jogando no computador da família e aproveitava todas as oportunidades para explorar a Web.",
          read_article: "Ler Artigo",
          card_cap: "Legenda do cartão",
          ibouge_title: "iBouge Lança Plataforma Global de Geo-Networking para Empresas",
          ibouge_updated: "Última atualização: 07/05/2019",
          ibouge_now_description: "O iBouge agora oferece páginas empresariais para empresas em todo o mundo. As empresas podem se registrar na plataforma de mapeamento e alcançar instantaneamente um público global.",

          dashboard: "Meu Painel",
          mapOverview: "Visão Geral do Mapa",
          businessProfile: "Perfil Empresarial",
          admin: "Admin",
          about: "Sobre",
          contact: "Contato",
          mission: "Missão",
          demo: "Demonstração",
          press: "Imprensa",
          blog: "Blog",
          privacy: "Privacidade",
          terms: "Termos de Serviço",

          typeToSearch: "Digite para pesquisar",
          searching: "Pesquisando...",
          account: "Conta",
          notifications: "Notificações",
          inbox: "Caixa de Entrada",
          logout: "Sair",

          users: "Usuários",
          events: "Eventos",
          microblogs: "Microblogs",
          business: "Negócios",
          myProfile: "Meu Perfil",

          globalNewsFeed: "Feed de Notícias Global",
          whatsOnMind: "O que você está pensando?",
          usePhoto: "Usar Foto",
          close: "Fechar",
          usernameWall: "Mural de {{username}}",
          noStatusUpdates: "Nenhuma atualização de status aqui",
          typing: "Digitando",
          hidePostsInfo: "Ocultar publicações ajuda o iBouge a personalizar e melhorar seu conteúdo",
          hidden: "Oculto",
          post: "Publicar",
          reportPost: "Denunciar Publicação",
          deletePost: "Excluir Publicação",
          writeComment: "Escreva um Comentário",
          deleteComment: "Excluir Comentário",
          addCommentText: "Por favor, adicione algum texto nos comentários",
          noPosts: "Desculpe! Ainda não há publicações disponíveis para esta localização. Verifique outro local.",
          startConversation: "Iniciar Conversa",
          friendsSelected: "Amigo(s) Selecionado(s)",

          localEvents: "Eventos Locais",
          myMicroblogs: "Meus Microblogs",
          edit: "Editar",
          addNew: "Adicionar Novo",

          addCity: "Adicionar Cidade",
          usernameConnection: "Conexões de {{username}}",
          selectOneFriend: "Por favor, selecione pelo menos um amigo",
          createGroup: "Criar Grupo",
          noChats: "Nenhum chat disponível",
          noNotifications: "Sem notificações",
          addNewEvent: "Adicionar Novo Evento",
          addNewMicroblog: "Adicionar Novo Microblog",
          addEvent: "Adicionar Evento",
          addMicroblog: "Adicionar Microblog",

          signUp: "Registrar-se",
          signIn: "Entrar",
          login: "Login",
          signupSteps: "Registre-se em poucos passos simples",
          welcomeLogin: "Bem-vindo! Faça login na sua conta",
          email: "Endereço de E-mail",
          password: "Senha",
          confirmPassword: "Confirmar Senha",
          type: "Tipo",
          personalAccount: "Conta Pessoal",
          businessAccount: "Conta Empresarial",
          firstName: "Nome",
          lastName: "Sobrenome",
          gender: "Gênero",
          male: "Masculino",
          female: "Feminino",
          preferNotSay: "Prefiro não dizer",
          other: "Outro",
          continue: "Continuar",
          forgetPassword: "Esqueceu a Senha?",
          loginMyAccount: "Entrar na Minha Conta",
          noAccount: "Não tem uma conta?",
          alreadyAccount: "Já tem uma conta?",

          businessCategory: "Categoria de Negócio",
          subscriptionType: "Tipo de Assinatura",
          selectPlan: "Selecione um plano",
          freePlan: "Plano Gratuito",
          premiumPlan: "Plano Premium",
          businessName: "Nome da Empresa",
          fillField: "Por favor, preencha o campo. Obrigado.",
          loginVerified: "Por favor, faça login após ser verificado",
          loginNewAccount: "Por favor, faça login com as credenciais da sua nova conta",
          accountDisabled: "Sua conta foi desativada pelo administrador.",
          premiumOffer: "O iBouge Premium oferece seguidores ilimitados e resultados de pesquisa priorizados para a sua página empresarial.",

          enterOtp: "Por favor, insira o código OTP enviado para o e-mail abaixo:",
          emailVerification: "Verificação de E-mail",
          resendOtp: "Reenviar OTP",
          otpExpires: "O OTP expira em {{time}} minutos",
          verify: "Verificar",
          restorePasswordText: "Digite seu endereço de e-mail e nós ajudaremos você a recuperar o acesso.",
          restorePassword: "Recuperar Senha",
          createNewPassword: "Criar Nova Senha",
          back: "Voltar",
          patentNumbers: "Números de Patente",
          copyright: "Direitos Autorais",
          allRightsReserved: "Todos os Direitos Reservados",

          setup_stepOne: "Configuração 1/3",
          setup_profile: "Configure seu perfil",
          about_me: "Sobre mim",
          about_me_placeholder: "Conte-nos um pouco sobre você",
          my_interests: "Meus Interesses",
          add_interests: "Adicionar Interesses",
          my_languages: "Minhas Línguas",
          add_languages: "Adicionar Línguas",

          setup_stepTwo: "Configuração 2/3",
          setup_location: "Configure sua localização",
          add_your_location: "Adicione sua localização: clique no mapa",
          enable_location: "Por favor, ative a localização do seu navegador para marcá-lo em seu código postal.",
          tag_neighborhood: "Por favor, marque-se em algum lugar do seu bairro para obter as melhores informações da comunidade e encontrar pessoas próximas a você.",
          location_access: "Precisamos de acesso à localização do seu dispositivo para oferecer recomendações personalizadas, conteúdo relevante e melhor funcionalidade. Sua localização só é acessada enquanto o aplicativo estiver aberto e em uso.",

          setup_stepThree: "Configuração 3/3",
          select_cities: "Selecione 3 cidades para seguir e receber notícias e atualizações da comunidade",
          first_city: "Primeira Cidade",
          search: "Pesquisar",
          second_city: "Segunda Cidade",
          third_city: "Terceira Cidade",
          selectFirstCity: "Por favor, selecione a primeira cidade",
          enterOneCity: "Por favor, insira pelo menos uma cidade primeiro",

          step_oneFour: "Configuração 1/4",
          businessSummary: "Resumo do Negócio",
          businessSummary_placeholder: "Conte-nos um pouco sobre o seu negócio",
          businessContact: "Contato da Empresa",
          companyWebsite: "Insira o site da empresa",
          businessOffers: "O que sua empresa oferece?",
          addProduct: "Adicionar Produto ou Serviço",

          agreeTerms: "Li, compreendi e concordo com os Termos e Condições.",
          agreePrivacy: "Li, compreendi e concordo com a Política de Privacidade.",
          continuePrivacy: "Continuar para Política de Privacidade",
          continuePayment: "Continuar para Página de Pagamento",
          createBusinessAccount: "Criar minha conta empresarial gratuita no iBouge",
          createPersonalAccount: "Criar minha conta pessoal gratuita no iBouge",
          activateMembership: "Ativar Associação",
          planName: "Nome do Plano",
          planType: "Tipo de Plano",
          planPrice: "Preço do Plano",
          activateBusinessPage: "Ativar minha Página Empresarial iBouge",

          summary: "Resumo",
          interests: "Interesses",
          languages: "Idiomas",
          businessOffer: "Oferta de Negócio",
          openingHours: "Horário de Funcionamento",
          timeZone: "Fuso Horário",
          aboutBusiness: "Sobre o Negócio",
          websiteUrl: "URL do Site",
          imageGallery: "Galeria de Imagens",
          noImage: "Nenhuma imagem encontrada na galeria",
          addMore: "Adicionar Mais",
          usernameFollowing: "{{username}} está a seguir",
          usernameFollowers: "Seguidores de {{username}}",
          shareProfile: "Partilhar Perfil",
          editCoverPhoto: "Editar Foto de Capa",
          urlCopied: "URL copiado para a área de transferência",

          upload: "Enviar",
          uploading: "Enviando",
          postDeleted: "Esta publicação foi excluída",
          activatePremium: "Ativar Plano Premium",
          sharePress: "Partilhar Imprensa",
          seen: "Visto",
          deletePicture: "Excluir Imagem",
          savePicture: "Salvar Imagem",
          sharePicture: "Partilhar Imagem",
          makeCoverPicture: "Definir como Foto de Capa",
          makeProfilePicture: "Definir como Foto de Perfil",
          copyURL: "Copiar URL",
          closed: "Fechado",
          notSet: "Não Definido",
          thankYou: "Obrigado!",
          loggingIntoIBouge: "Entrando no iBouge em",
          businessActivated: "Obrigado! A sua página empresarial foi ativada com sucesso.",
          shareTo: "Partilhar em",
          stepFourOfFour: "Etapa 4/4",

          step_OneTwo: "Etapa 1/2",
          event_details: "Detalhes do Evento",
          event_name: "Nome do Evento",
          sample_event: "Maior Desafio de Pizza 2022",
          event_category: "Categoria do Evento",
          start_date: "Data de Início",
          date_format: "dd/mm/aaaa",
          start_time: "Hora de Início",
          end_time: "Hora de Término",
          event_description: "Descrição do Evento",
          cover_photo: "Foto de Capa",
          next_to_location: "Próximo à Localização",
          step_TwoTwo: "Etapa 2/2",
          enter_location: "Insira os Detalhes da Localização",
          add_event_details: "Adicione detalhes do evento: clique no mapa",
          create_event: "Criar Evento",
          users_interested: "Usuários Interessados",
          going: "VAI",
          not_going: "NÃO VAI",
          invite: "Convidar",
          inviteUsers: "Convidar Usuários",
          typeToInvite: "Digite aqui para convidar um usuário",
          friendsGoing: "{{number}} dos seus amigos vão.",
          usersInterested: "{{number}} usuários estão interessados",
          bookmark: "Favoritar",
          bookmarked: "Adicionado aos Favoritos",

          microblog_name: "Nome do Microblog",
          add_location: "Adicionar localização: clique no mapa",
          search_address: "Pesquisar endereço",
          create: "Criar",
          public: "Público",
          private: "Privado",
          searchAddress: "Por favor, pesquise um endereço",
          selectImage: "Por favor, selecione a imagem",

          general: "Geral",
          location: "Localização",
          payments: "Pagamentos",

          companyWebsiteUrl: "URL do Site da Empresa",
          settings: "Configurações",
          wall_private: "Tornar meu mural visível apenas para amigos",
          profile_private: "Tornar meu perfil visível apenas para meus amigos",
          friends_list_private: "Mostrar minha lista de amigos apenas para meus amigos",
          anyone_follow: "Qualquer pessoa pode me seguir",
          accept_messages: "Aceito novas mensagens de fora do meu grupo de amigos",
          block_list: "Lista de Bloqueio",
          block_users: "Bloquear Usuários",
          type_to_name: "Digite o nome",
          block_list_empty: "A lista de bloqueio está vazia",

          wall_notifications: "Notificações do mural",
          event_invitations: "Convites para eventos",
          friend_requests: "Notificações de pedidos de amizade",
          message_notifications: "Notificações de mensagens",
          deactivateAccount: "Desativar Conta",
          deleteAccount: "Excluir Conta",
          cancel: "Cancelar",
          save: "Salvar",

          topCities: "Principais Cidades",
          chooseLocations: "Escolha até três locais para seguir atualizações. Selecione uma cidade para atualizar para uma nova cidade",
          city1: "Cidade 1",
          city2: "Cidade 2",
          city3: "Cidade 3",
          searchCity: "Procurar uma cidade",

          flagContent: "Denunciar conteúdo impróprio",
          selectReportType: "Selecionar tipo de denúncia",
          unhidePost: "Mostrar publicação",
          hidePost: "Ocultar publicação",
          cancelSubscription: "Cancelar subscrição",
          accountUpdated: "A conta foi atualizada",
          subscriptionAmount: "Valor da subscrição",
          subscriptionStartDate: "Data de início da subscrição",
          subscriptionEndDate: "Data de término da subscrição",
          locationUpdated: "A localização foi atualizada",
          notificationsUpdated: "As notificações foram atualizadas",
          privacyUpdated: "A privacidade foi atualizada",
          undo: "Desfazer",
          block: "Bloquear",
          unblock: "Desbloquear",
          confirm: "Confirmar",
          activateAccount: "Ativar conta",
          accountDeactivated: "Oops! A sua conta está atualmente desativada",
          confirmDeleteAccount: "Tem a certeza de que deseja eliminar a conta?",
          confirmActivateAccount: "Tem a certeza de que deseja ativar a conta?",

          delivered: "Entregue",
          download: "Transferir",
          noChatFound: "Nenhum chat encontrado",
          messageSeenBy: "Mensagem vista pelo(s) seguinte(s) utilizador(es)",
          othersCount: "+ {{number}} outros",
          notSelectedYet: "Ainda não selecionado",
          nameTyping: "{{name}} está a escrever...",
          twoTyping: "{{name1}} e {{name2}} estão a escrever...",
          multipleTyping: "{{name1}} e mais {{number}} estão a escrever...",
          wallPrivate: "Este mural é privado",
          profileHidden: "O perfil deste utilizador está oculto",
          profilePrivate: "O perfil deste utilizador é privado",
          follow: "Seguir",
          following: "A seguir",
          and: "e",
          others: "{{number}} outros",
          acceptFriendRequest: "Aceitar pedido de amizade",
          friendRequestSent: "Pedido de amizade enviado",
          friends: "Amigos",
          confirmUnfollow: "Tem a certeza de que deseja deixar de seguir?",
          confirmUnfriend: "Tem a certeza de que deseja remover dos amigos?",
          upgradeMessage: "Por favor, atualize para o nosso plano premium para desbloquear seguidores ilimitados na sua página comercial.",
          upgrade: "Atualizar",

          noConnectionsFound: "Nenhuma conexão encontrada",
          followersPrivate: "A lista de seguidores deste utilizador é privada",
          friendsPrivate: "A lista de amigos deste utilizador é privada",
          addAsFriend: "Adicionar como amigo",
          add: "Adicionar",
          unfriend: "Remover amigo",
          unfollow: "Deixar de seguir",
          chat: "Conversa",
          inviteToChat: "Convidar para conversar",

        }
      },
      ja: {
        translation: {

          introducing: "iBouge の紹介",
          whatIsIBouge: "iBouge<0>®</0>とは何ですか？",
          ibougeIntro: "iBougeは、人々、製品、情報をグローバルマップインターフェース上に配置し、世界中のインターネット利用者にとってよりアクセスしやすく、見つけやすくすることで、新しい形の交流を可能にするマッピングプラットフォームです。",
          ibougeDescription: "当社の特許取得済みのユニークなグローバルマップインターフェースは、コンテンツを新しい方法で分類し、人々や情報が世界規模で見つけられるようにします。iBouge ® のユーザーは世界中の誰とでもつながることができ、企業は所在地に関係なく、世界中のあらゆるオーディエンスにリーチできます。",
          sign_up: "サインアップ",
          howDoISignUp: "わかりました、納得しました。<1/><0>どうやってサインアップすればいいですか？</0>",
          products_intro: "現在、マップ上で 4 つの製品を提供しています:",
          product1: "近くの人と出会う",
          product2: "グローバルビジネスページ",
          product3: "関心のある場所についてのマップベースのチャット",
          product4: "地図上にピン留めされ、その地域をフォローしている人に配信されるローカルイベント。",
          whatDifferentiates: "<0>このプラットフォームが他のソーシャルメディア企業と</0>異なる点は何ですか？",
          business_price: "ビジネスページは年間わずか25ドルで利用可能です。",
          signup_cta: "今すぐ年間わずか25ドルでビジネスを登録",

          whoShouldSignUp: "誰がアカウントを登録すべきで、その理由は？",
          twoTypesAccounts: "私たちは2種類のアカウントを提供しています。",
          businessAccountDescription: "当社のグローバルビジネスページは、幅広いマーケティング露出と即時の国際的な認知を求める中小企業向けに設計されています。",
          businessPageFeatures: "当社のビジネスページは、Googleマップのように企業情報を表示し、地図上での検索性に加え、グループチャット、ダイレクトメッセージ、ソーシャルメディア機能、企業ブランドや更新のための個人ウォールを備えています。",
          accountTypes: "無料の個人アカウントと有料のビジネスアカウントがあります。",
          soldQuestion: "なるほど、登録方法は？",
          signUpInstructions: "登録ページで無料ユーザーまたは有料ビジネスユーザーとしてサインアップし、アカウントタイプのドロップダウンから希望のタイプを選択できます。",
          step1: "ステップ 1",
          step2: "ステップ 2",
          step3: "ステップ 3",
          step4: "ステップ 4",
          done: "終わり",
          step1_desc: "会社の詳細を入力し、会社のウェブサイトとプロフィール写真を追加してください。",
          step2_desc: "iBouge ® と位置情報を共有するようにブラウザを有効にしてください。ビジネスの所在地をタグ付けするためです。",
          step3_desc: "ニュースフィードの更新を受け取るために、お気に入りの都市を3つ選択してください。新しい場所を探索するためにいつでも変更できます。",
          step4_desc: "安全な決済パートナーStripeを使用して、新しいメンバーシップを開始するためにクレジットカード情報を入力してください。",
          enjoyBenefits: "そして、当社プラットフォームの利点を楽しみ始めましょう",
          done_steps: "あなたのビジネスページは自動的に有効化され、その後プラットフォームにログインします。",

          profileUpdated: "プロフィールが更新されました",
          deactivateConfirm: "アカウントを無効にしてもよろしいですか？",
          enterTextOrImage: "テキストを入力するか、画像を選択してください",
          fileTooBig: "ファイルサイズが大きすぎます",
          selectFileFirst: "まずファイルを選択してください",
          waitForUpload: "メディアのアップロードをお待ちください",
          alreadyExistInGroup: "グループ内に既に存在します",
          enterMsgFirst: "最初にメッセージを入力してください",
          someFilesTooBig: "一部のファイルは大きすぎて選択されませんでした。",
          enterMessage: "メッセージを入力してください",
          enterNewPassword: "新しいパスワードを入力してください",

          contact_us: "お問い合わせ",
          write_to_us: "ご連絡ください",
          message_intro: "ぜひご意見をお聞かせください！ メッセージを残していただければ、すぐにご連絡いたします。",
          your_name: "お名前",
          subject: "件名",
          query: "お問い合わせ",
          send_message: "メッセージを送信",
          message: "メッセージ",
          submit: "送信",
          global_hq: "グローバル本社:",
          address: "アメリカ合衆国 ワシントン州レドモンド 98052",
          hours: "月 - 金: 9:00-17:00 PST",

          mission_title: "iBouge の使命",
          population_globe: "人口グローブ",
          expanding_world: "あなたの世界を広げる",
          platform_intro: "iBouge の特許取得済みプラットフォームは、世界中のあらゆる国でビジネス、人、情報を見つけることを可能にします...",
          mission_statement: "私たちの使命は、人々、企業、コミュニティのためにウェブ上で最もオープンな情報ポータルとなることです。",
          platform_use: "iBouge を使えば、キーワード検索を入力せずに、世界中の誰とでもつながったり、どんな企業でも見つけることができます...",
          shops_future: "まもなくプラットフォーム上に製品販売のショップを開設し、場所ごとに買い物ができるようになります。",
          global_connect: "世界はかつてないほどグローバルにつながっており、iBouge は情報を中央化しオープンにします...",
          fingertips: "iBouge があれば、世界はあなたの指先にあります。",

          press_statement: "プレスリリース",
          month: "MM",
          year: "YYYY",
          search_article: "記事を検索",
          lisa_leslie: "リサ・レスリー",
          lisa_title: "境界を越えて: リサ・レスリーが世界を少し小さくする方法",
          lisa_updated: "最終更新日 2019年7月05日",
          lisa_description: "リサ・レスリーは幼い頃からテクノロジーに夢中でした。家族のコンピューターでゲームをし、Webで試行錯誤する機会を逃しませんでした。",
          read_article: "記事を読む",
          card_cap: "カード見出し",
          ibouge_title: "iBouge、企業向けグローバルジオネットワーキングプラットフォームを発表",
          ibouge_updated: "最終更新日 2019年7月05日",
          ibouge_now_description: "iBouge は現在、世界中の企業にビジネスページを提供しています。企業はマッピングプラットフォームに登録し、即座にグローバルなオーディエンスにリーチできます。",

          dashboard: "マイダッシュボード",
          mapOverview: "マップ概要",
          businessProfile: "ビジネスプロフィール",
          admin: "管理者",
          about: "概要",
          contact: "お問い合わせ",
          mission: "使命",
          demo: "デモ",
          press: "プレス",
          blog: "ブログ",
          privacy: "プライバシー",
          terms: "利用規約",
          typeToSearch: "検索するには入力",
          searching: "検索中...",
          account: "アカウント",
          notifications: "通知",
          inbox: "受信トレイ",
          logout: "ログアウト",

          users: "ユーザー",
          events: "イベント",
          microblogs: "マイクロブログ",
          business: "ビジネス",
          myProfile: "マイプロフィール",

          globalNewsFeed: "グローバルニュースフィード",
          whatsOnMind: "今何を考えていますか？",
          usePhoto: "写真を使用",
          close: "閉じる",
          usernameWall: "{{username}}のウォール",
          noStatusUpdates: "ここにはステータスの更新はありません",
          typing: "入力中",
          hidePostsInfo: "投稿を非表示にすると、iBougeがあなたのコンテンツをよりパーソナライズして改善します",
          hidden: "非表示",
          post: "投稿",
          reportPost: "投稿を報告",
          deletePost: "投稿を削除",
          writeComment: "コメントを書く",
          deleteComment: "コメントを削除",
          addCommentText: "コメントにテキストを追加してください",
          noPosts: "申し訳ありません！この場所にはまだ投稿がありません。他の場所をチェックしてください。",
          startConversation: "会話を開始",
          friendsSelected: "友達が選択されました",

          localEvents: "ローカルイベント",
          myMicroblogs: "自分のマイクロブログ",
          edit: "編集",
          addNew: "新規追加",

          addCity: "都市を追加",
          usernameConnection: "{{username}} のつながり",
          selectOneFriend: "少なくとも1人の友達を選択してください",
          createGroup: "グループを作成",
          noChats: "利用可能なチャットはありません",
          noNotifications: "通知はありません",
          addNewEvent: "新しいイベントを追加",
          addNewMicroblog: "新しいマイクロブログを追加",
          addEvent: "イベントを追加",
          addMicroblog: "マイクロブログを追加",

          signUp: "サインアップ",
          signIn: "サインイン",
          login: "ログイン",
          signupSteps: "簡単なステップでサインアップ",
          welcomeLogin: "ようこそ！アカウントにログインしてください",
          email: "メールアドレス",
          password: "パスワード",
          confirmPassword: "パスワードを確認",
          type: "タイプ",
          personalAccount: "個人アカウント",
          businessAccount: "ビジネスアカウント",
          firstName: "名",
          lastName: "姓",
          gender: "性別",
          male: "男性",
          female: "女性",
          preferNotSay: "回答しない",
          other: "その他",
          continue: "続ける",
          forgetPassword: "パスワードを忘れましたか？",
          loginMyAccount: "マイアカウントにログイン",
          noAccount: "アカウントをお持ちではありませんか？",
          alreadyAccount: "すでにアカウントをお持ちですか？",

          businessCategory: "事業カテゴリ",
          subscriptionType: "サブスクリプションタイプ",
          selectPlan: "プランを選択",
          freePlan: "無料プラン",
          premiumPlan: "プレミアムプラン",
          businessName: "会社名",
          fillField: "フィールドに入力してください、ありがとうございます",
          loginVerified: "認証後にログインしてください",
          loginNewAccount: "新しく作成したアカウントの認証情報でログインしてください",
          accountDisabled: "あなたのアカウントは管理者によって無効化されました。",
          premiumOffer: "iBouge Premium は、無制限のフォロワーとビジネスページの検索結果優先を提供します。",

          enterOtp: "以下のメールに送信されたOTPを入力してください:",
          emailVerification: "メール認証",
          resendOtp: "OTPを再送信",
          otpExpires: "OTPは{{time}}分で有効期限が切れます",
          verify: "確認",
          restorePasswordText: "メールアドレスを入力してください。アカウント復旧をお手伝いします。",
          restorePassword: "パスワードを復元",
          createNewPassword: "新しいパスワードを作成",
          back: "戻る",
          patentNumbers: "特許番号",
          copyright: "著作権",
          allRightsReserved: "全著作権所有",

          setup_stepOne: "設定 1/3",
          setup_profile: "プロフィールを設定する",
          about_me: "自己紹介",
          about_me_placeholder: "簡単に自己紹介してください",
          my_interests: "興味・関心",
          add_interests: "興味を追加",
          my_languages: "使用言語",
          add_languages: "言語を追加",

          setup_stepTwo: "セットアップ 2/3",
          setup_location: "位置情報を設定してください",
          add_your_location: "位置情報を追加: 地図をクリック",
          enable_location: "ブラウザで位置情報を有効にし、郵便番号でタグ付けしてください。",
          tag_neighborhood: "近所のどこかで自分をタグ付けすると、地域情報を入手し周囲の人々を見つけやすくなります。",
          location_access: "パーソナライズされたおすすめ、関連コンテンツ、機能改善のためにデバイスの位置情報へのアクセスが必要です。位置情報はアプリを開いて使用中のみ取得されます。",

          setup_stepThree: "設定 3/3",
          select_cities: "地域ニュースと更新情報を受け取るために3つの都市を選択してください",
          first_city: "最初の都市",
          search: "検索",
          second_city: "2番目の都市",
          third_city: "3番目の都市",
          selectFirstCity: "まず都市を選択してください",
          enterOneCity: "まず少なくとも1つの都市を入力してください",

          step_oneFour: "設定 1/4",
          businessSummary: "ビジネス概要",
          businessSummary_placeholder: "あなたのビジネスについて少し教えてください",
          businessContact: "ビジネス連絡先",
          companyWebsite: "会社のウェブサイトを入力",
          businessOffers: "あなたのビジネスは何を提供していますか？",
          addProduct: "製品またはサービスを追加",

          agreeTerms: "利用規約を読み、理解し、同意しました。",
          agreePrivacy: "プライバシーポリシーを読み、理解し、同意しました。",
          continuePrivacy: "プライバシーポリシーに進む",
          continuePayment: "支払いページに進む",
          createBusinessAccount: "無料のiBougeビジネスアカウントを作成",
          createPersonalAccount: "無料のiBouge個人アカウントを作成",
          activateMembership: "メンバーシップを有効化",
          planName: "プラン名",
          planType: "プランタイプ",
          planPrice: "プラン価格",
          activateBusinessPage: "iBougeビジネスページを有効化",

          summary: "概要",
          interests: "興味",
          languages: "言語",
          businessOffer: "ビジネスオファー",
          openingHours: "営業時間",
          timeZone: "タイムゾーン",
          aboutBusiness: "事業について",
          websiteUrl: "ウェブサイトURL",
          imageGallery: "画像ギャラリー",
          noImage: "ギャラリーに画像が見つかりません",
          addMore: "さらに追加",
          usernameFollowing: "{{username}} はフォロー中",
          usernameFollowers: "{{username}} のフォロワー",
          shareProfile: "プロフィールを共有",
          editCoverPhoto: "カバー写真を編集",
          urlCopied: "URLがクリップボードにコピーされました",

          upload: "アップロード",
          uploading: "アップロード中",
          postDeleted: "この投稿は削除されました",
          activatePremium: "プレミアムプランを有効化",
          sharePress: "投稿を共有",
          seen: "閲覧済み",
          deletePicture: "画像を削除",
          savePicture: "画像を保存",
          sharePicture: "画像を共有",
          makeCoverPicture: "カバー写真に設定",
          makeProfilePicture: "プロフィール写真に設定",
          copyURL: "URLをコピー",
          closed: "閉じました",
          notSet: "未設定",
          thankYou: "ありがとうございます！",
          loggingIntoIBouge: "iBouge にログイン中...",
          businessActivated: "ありがとうございます！あなたのビジネスページが有効になりました。",
          shareTo: "共有先",
          stepFourOfFour: "ステップ 4/4",

          step_OneTwo: "ステップ 1/2",
          event_details: "イベント詳細",
          event_name: "イベント名",
          sample_event: "最大のピザチャレンジ 2022",
          event_category: "イベントカテゴリー",
          start_date: "開始日",
          date_format: "年/月/日",
          start_time: "開始時間",
          end_time: "終了時間",
          event_description: "イベントの説明",
          cover_photo: "カバーフォト",
          next_to_location: "場所へ進む",
          step_TwoTwo: "ステップ 2/2",
          enter_location: "場所の詳細を入力",
          add_event_details: "イベントの詳細を追加: 地図をクリックしてください",
          create_event: "イベントを作成",
          users_interested: "ユーザーが興味を持っています",
          going: "参加予定",
          not_going: "不参加",
          invite: "招待",
          inviteUsers: "ユーザーを招待",
          typeToInvite: "ユーザーを招待するにはここに入力",
          friendsGoing: "{{number}}人の友達が参加します。",
          usersInterested: "{{number}}人のユーザーが興味を持っています",
          bookmark: "ブックマーク",
          bookmarked: "ブックマーク済み",

          microblog_name: "マイクロブログ名",
          add_location: "場所を追加: 地図をクリック",
          search_address: "住所を検索",
          create: "作成",
          public: "公開",
          private: "非公開",
          searchAddress: "住所を検索してください",
          selectImage: "画像を選択してください",

          general: "一般",
          location: "場所",
          payments: "支払い",

          companyWebsiteUrl: "会社のウェブサイトURL",
          settings: "設定",
          wall_private: "自分のウォールを友達のみに非公開にする",
          profile_private: "自分のプロフィールを友達のみに非公開にする",
          friends_list_private: "友達リストを友達のみに表示する",
          anyone_follow: "誰でもフォローできます",
          accept_messages: "友達以外からの新しいメッセージを受け入れる",
          block_list: "ブロックリスト",
          block_users: "ユーザーをブロック",
          type_to_name: "名前を入力",
          block_list_empty: "ブロックリストは空です",

          wall_notifications: "ウォール通知",
          event_invitations: "イベント招待",
          friend_requests: "友達リクエスト通知",
          message_notifications: "メッセージ通知",
          deactivateAccount: "アカウントを無効化",
          deleteAccount: "アカウントを削除",
          cancel: "キャンセル",
          save: "保存",

          topCities: "人気の都市",
          chooseLocations: "更新をフォローするために最大3つの場所を選択します。新しい都市に変更するには都市を選択してください",
          city1: "都市 1",
          city2: "都市 2",
          city3: "都市 3",
          searchCity: "都市を検索",

          flagContent: "不適切なコンテンツを報告",
          selectReportType: "報告の種類を選択",
          unhidePost: "投稿を表示",
          hidePost: "投稿を非表示",
          cancelSubscription: "サブスクリプションをキャンセル",
          accountUpdated: "アカウントが更新されました",
          subscriptionAmount: "サブスクリプション金額",
          subscriptionStartDate: "サブスクリプション開始日",
          subscriptionEndDate: "サブスクリプション終了日",
          locationUpdated: "位置情報が更新されました",
          notificationsUpdated: "通知が更新されました",
          privacyUpdated: "プライバシーが更新されました",
          undo: "元に戻す",
          block: "ブロック",
          unblock: "ブロック解除",
          confirm: "確認",
          activateAccount: "アカウントを有効化",
          accountDeactivated: "おっと！あなたのアカウントは現在無効です",
          confirmDeleteAccount: "アカウントを削除してもよろしいですか？",
          confirmActivateAccount: "アカウントを有効化してもよろしいですか？",

          delivered: "配信済み",
          download: "ダウンロード",
          noChatFound: "チャットが見つかりません",
          messageSeenBy: "次のユーザーがメッセージを確認しました",
          othersCount: "+ その他{{number}}人",
          notSelectedYet: "まだ選択されていません",
          nameTyping: "{{name}}が入力中...",
          twoTyping: "{{name1}}と{{name2}}が入力中...",
          multipleTyping: "{{name1}}とその他{{number}}人が入力中...",
          wallPrivate: "このウォールは非公開です",
          profileHidden: "このユーザーのプロフィールは非表示です",
          profilePrivate: "このユーザーのプロフィールは非公開です",
          follow: "フォロー",
          following: "フォロー中",
          and: "と",
          others: "その他{{number}}人",
          acceptFriendRequest: "友達リクエストを承認",
          friendRequestSent: "友達リクエストを送信しました",
          friends: "友達",
          confirmUnfollow: "フォローを解除してもよろしいですか？",
          confirmUnfriend: "友達を解除してもよろしいですか？",
          upgradeMessage: "ビジネスページで無制限のフォロワーを獲得するには、プレミアムプランにアップグレードしてください。",
          upgrade: "アップグレード",

          noConnectionsFound: "接続が見つかりません",
          followersPrivate: "このユーザーのフォロワーリストは非公開です",
          friendsPrivate: "このユーザーの友達リストは非公開です",
          addAsFriend: "友達として追加",
          add: "追加",
          unfriend: "友達を解除",
          unfollow: "フォローする",
          chat: "チャット",
          inviteToChat: "チャットに招待",
        }
      },
      ko: {
        translation: {

          introducing: "iBouge 소개",
          whatIsIBouge: "iBouge<0>®</0>란 무엇인가요?",
          ibougeIntro: "iBouge는 사람, 제품 및 정보를 글로벌 지도 인터페이스에 배치하여 전 세계 인터넷 사용자들이 더 쉽게 접근하고 찾을 수 있도록 하며, 새로운 방식으로 상호작용할 수 있게 하는 매핑 플랫폼입니다.",
          ibougeDescription: "우리의 특허받은 독특한 글로벌 지도 인터페이스는 콘텐츠를 새로운 방식으로 분류하고, 사람들이 발견되고 콘텐츠가 전 세계적으로 보일 수 있도록 합니다. iBouge ® 사용자는 전 세계 누구와도 연결할 수 있으며, 기업은 위치에 상관없이 전 세계의 모든 청중에게 도달할 수 있습니다.",
          sign_up: "가입하기",
          howDoISignUp: "좋아요, 가입할게요.<1/><0>어떻게 가입하나요?</0>",
          products_intro: "현재 지도 인터페이스에서 4가지 제품을 제공합니다:",
          product1: "주변 사람 만나기",
          product2: "글로벌 비즈니스 페이지",
          product3: "관심 지점에 대한 지도 기반 채팅",
          product4: "지도에 고정되어 해당 지역을 팔로우하는 모든 사람에게 방송되는 지역 이벤트.",
          whatDifferentiates: "<0>이 플랫폼이 다른 소셜 미디어 회사와</0>차별화되는 점은 무엇입니까?",
          business_price: "비즈니스 페이지는 연간 단 25달러입니다.",
          signup_cta: "지금 바로 연간 $25로 비즈니스 등록하기",

          whoShouldSignUp: "누가 계정을 등록해야 하며 그 이유는 무엇인가요?",
          twoTypesAccounts: "우리는 두 가지 유형의 계정을 제공합니다.",
          businessAccountDescription: "당사의 글로벌 비즈니스 페이지는 넓은 마케팅 노출과 즉각적인 국제 가시성을 원하는 중소기업을 위해 설계되었습니다.",
          businessPageFeatures: "당사의 비즈니스 페이지는 Google 지도처럼 회사 정보를 나열하며, 지도 검색 기능 외에도 그룹 채팅, 직접 메시지, 소셜 미디어 기능, 회사 브랜딩과 업데이트를 위한 개인 월을 제공합니다.",
          accountTypes: "무료 개인 계정과 유료 비즈니스 계정이 있습니다.",
          soldQuestion: "좋아요, 가입 방법은 어떻게 되나요?",
          signUpInstructions: "등록 페이지에서 무료 사용자 또는 유료 비즈니스 사용자로 가입하고, 계정 유형 드롭다운에서 원하는 계정 유형을 선택할 수 있습니다.",
          step1: "1단계",
          step2: "2단계",
          step3: "3단계",
          step4: "4단계",
          done: "완료",
          step1_desc: "회사 정보를 입력하고, 회사 웹사이트와 프로필 사진을 추가하세요.",
          step2_desc: "브라우저가 iBouge ® 와 위치를 공유하도록 활성화하여 귀하의 비즈니스를 해당 위치에 태그할 수 있도록 해주세요.",
          step3_desc: "뉴스피드 업데이트를 받기 위해 좋아하는 상위 3개 도시를 선택하세요. 언제든지 도시를 변경하여 새로운 장소를 탐험할 수 있습니다.",
          step4_desc: "안전한 결제 파트너 Stripe를 사용하여 새 멤버십을 시작하기 위해 신용카드 정보를 입력하세요.",
          enjoyBenefits: "그리고 우리 플랫폼을 사용하는 이점을 즐기기 시작하세요",
          done_steps: "비즈니스 페이지가 자동으로 활성화되고 플랫폼에 로그인됩니다.",

          profileUpdated: "프로필이 업데이트되었습니다",
          deactivateConfirm: "계정을 비활성화하시겠습니까?",
          enterTextOrImage: "텍스트를 입력하거나 이미지를 선택하세요",
          fileTooBig: "파일 크기가 너무 큽니다",
          selectFileFirst: "먼저 파일을 선택하세요",
          waitForUpload: "미디어 업로드를 기다려 주세요",
          alreadyExistInGroup: "이미 그룹에 존재합니다",
          enterMsgFirst: "먼저 메시지를 입력하세요",
          someFilesTooBig: "일부 파일이 너무 커서 선택되지 않았습니다.",
          enterMessage: "메시지를 입력하세요",
          enterNewPassword: "새 비밀번호를 입력하세요",

          contact_us: "문의하기",
          write_to_us: "저희에게 연락하세요",
          message_intro: "여러분의 의견을 듣고 싶습니다! 메시지를 남겨주시면 곧 연락드리겠습니다.",
          your_name: "이름",
          subject: "제목",
          query: "문의",
          send_message: "메시지 보내기",
          message: "메시지",
          submit: "제출",
          global_hq: "글로벌 본사:",
          address: "미국 워싱턴주 레드몬드 98052",
          hours: "월 - 금: 9:00-17:00 PST",

          mission_title: "iBouge의 사명",
          population_globe: "인구 지구본",
          expanding_world: "당신의 세계 확장",
          platform_intro: "iBouge의 특허받은 플랫폼은 전 세계 어떤 나라에서도 비즈니스, 사람, 정보를 찾을 수 있게 합니다...",
          mission_statement: "우리의 사명은 사람, 기업, 커뮤니티를 위한 가장 개방된 정보 포털이 되는 것입니다.",
          platform_use: "iBouge를 통해 키워드 검색 없이 전 세계 누구와도 연결하고 어떤 비즈니스든 찾을 수 있습니다...",
          shops_future: "곧 플랫폼에서 제품을 판매하는 상점을 열어 위치별로 쇼핑할 수 있습니다.",
          global_connect: "세계는 그 어느 때보다 글로벌하게 연결되어 있으며, iBouge는 당신의 정보를 중앙화하고 개방하여...",
          fingertips: "iBouge와 함께라면, 세상이 당신의 손끝에 있습니다.",

          press_statement: "언론 성명",
          month: "MM",
          year: "YYYY",
          search_article: "기사 검색",
          lisa_leslie: "리사 레슬리",
          lisa_title: "경계 없는 세상: 리사 레슬리가 세상을 조금 더 가깝게 만드는 방법",
          lisa_updated: "마지막 업데이트 2019년 7월 05일",
          lisa_description: "리사 레슬리는 어린 시절부터 기술에 매료되었습니다. 가족 컴퓨터로 게임을 하며 자라났고, 웹에서 탐구할 기회를 놓치지 않았습니다.",
          read_article: "기사 읽기",
          card_cap: "카드 제목",
          ibouge_title: "iBouge, 기업을 위한 글로벌 지오 네트워킹 플랫폼 출시",
          ibouge_updated: "마지막 업데이트 2019년 7월 05일",
          ibouge_now_description: "iBouge는 이제 전 세계 기업에 비즈니스 페이지를 제공합니다. 기업은 맵핑 플랫폼에 등록하여 즉시 글로벌 청중에게 도달할 수 있습니다.",

          dashboard: "내 대시보드",
          mapOverview: "지도 개요",
          businessProfile: "비즈니스 프로필",
          admin: "관리자",
          about: "소개",
          contact: "연락처",
          mission: "사명",
          demo: "데모",
          press: "보도자료",
          blog: "블로그",
          privacy: "개인정보 처리방침",
          terms: "서비스 약관",

          typeToSearch: "검색하려면 입력하세요",
          searching: "검색 중...",
          account: "계정",
          notifications: "알림",
          inbox: "받은편지함",
          logout: "로그아웃",

          users: "사용자",
          events: "이벤트",
          microblogs: "마이크로블로그",
          business: "비즈니스",
          myProfile: "내 프로필",

          globalNewsFeed: "글로벌 뉴스피드",
          whatsOnMind: "무슨 생각을 하고 있나요?",
          usePhoto: "사진 사용",
          close: "닫기",
          usernameWall: "{{username}}의 게시판",
          noStatusUpdates: "여기에 상태 업데이트가 없습니다",
          typing: "입력 중",
          hidePostsInfo: "게시물을 숨기면 iBouge가 콘텐츠를 개인화하고 개선하는 데 도움이 됩니다",
          hidden: "숨김",
          post: "게시",
          reportPost: "게시물 신고",
          deletePost: "게시물 삭제",
          writeComment: "댓글 작성",
          deleteComment: "댓글 삭제",
          addCommentText: "댓글에 텍스트를 입력해주세요",
          noPosts: "죄송합니다! 이 위치에는 아직 게시물이 없습니다. 다른 위치를 확인해 보세요.",
          startConversation: "대화 시작",
          friendsSelected: "친구 선택됨",

          localEvents: "지역 이벤트",
          myMicroblogs: "내 마이크로블로그",
          edit: "편집",
          addNew: "새로 추가",

          addCity: "도시 추가",
          usernameConnection: "{{username}}의 연결",
          selectOneFriend: "친구를 최소 한 명 선택하세요",
          createGroup: "그룹 만들기",
          noChats: "채팅이 없습니다",
          noNotifications: "알림이 없습니다",
          addNewEvent: "새 이벤트 추가",
          addNewMicroblog: "새 마이크로블로그 추가",
          addEvent: "이벤트 추가",
          addMicroblog: "마이크로블로그 추가",

          signUp: "가입하기",
          signIn: "로그인",
          login: "로그인",
          signupSteps: "몇 가지 간단한 단계로 가입하세요",
          welcomeLogin: "환영합니다! 계정에 로그인하세요",
          email: "이메일 주소",
          password: "비밀번호",
          confirmPassword: "비밀번호 확인",
          type: "유형",
          personalAccount: "개인 계정",
          businessAccount: "비즈니스 계정",
          firstName: "이름",
          lastName: "성",
          gender: "성별",
          male: "남성",
          female: "여성",
          preferNotSay: "말하지 않음",
          other: "기타",
          continue: "계속하기",
          forgetPassword: "비밀번호를 잊으셨나요?",
          loginMyAccount: "내 계정에 로그인",
          noAccount: "계정이 없으신가요?",
          alreadyAccount: "이미 계정이 있으신가요?",

          businessCategory: "비즈니스 카테고리",
          subscriptionType: "구독 유형",
          selectPlan: "요금제를 선택하세요",
          freePlan: "무료 요금제",
          premiumPlan: "프리미엄 요금제",
          businessName: "상호명",
          fillField: "필드를 입력해주세요. 감사합니다",
          loginVerified: "인증 후 로그인 해주세요",
          loginNewAccount: "새로 만든 계정 자격 증명으로 로그인 해주세요",
          accountDisabled: "관리자에 의해 계정이 비활성화되었습니다.",
          premiumOffer: "iBouge Premium은 무제한 팔로워와 비즈니스 페이지의 우선 검색 결과를 제공합니다.",

          enterOtp: "아래 이메일로 전송된 OTP를 입력하세요:",
          emailVerification: "이메일 인증",
          resendOtp: "OTP 다시 보내기",
          otpExpires: "OTP는 {{time}}분 후 만료됩니다",
          verify: "확인",
          restorePasswordText: "이메일 주소를 입력하시면 비밀번호를 복구할 수 있습니다.",
          restorePassword: "비밀번호 복구",
          createNewPassword: "새 비밀번호 만들기",
          back: "뒤로",
          patentNumbers: "특허 번호",
          copyright: "저작권",
          allRightsReserved: "판권 소유",

          setup_stepOne: "설정 1/3",
          setup_profile: "프로필 설정",
          about_me: "자기소개",
          about_me_placeholder: "자신에 대해 간단히 소개해주세요",
          my_interests: "내 관심사",
          add_interests: "관심사 추가",
          my_languages: "내 언어",
          add_languages: "언어 추가",

          setup_stepTwo: "설정 2/3",
          setup_location: "위치 설정",
          add_your_location: "위치 추가: 지도를 클릭하세요",
          enable_location: "브라우저 위치를 활성화하여 우편번호에 태그하세요.",
          tag_neighborhood: "최상의 커뮤니티 정보를 얻고 주변 사람들을 찾기 위해 이웃 내에서 위치를 태그하세요.",
          location_access: "맞춤형 추천, 관련 콘텐츠 및 기능 향상을 위해 기기의 위치 접근이 필요합니다. 위치 정보는 앱이 열려 있을 때만 사용됩니다.",

          setup_stepThree: "설정 3/3",
          select_cities: "커뮤니티 뉴스 및 업데이트를 받기 위해 도시 3곳을 선택하세요",
          first_city: "첫 번째 도시",
          search: "검색",
          second_city: "두 번째 도시",
          third_city: "세 번째 도시",
          selectFirstCity: "먼저 도시를 선택하세요",
          enterOneCity: "먼저 최소한 한 개의 도시를 입력하세요",

          step_oneFour: "설정 1/4",
          businessSummary: "비즈니스 요약",
          businessSummary_placeholder: "비즈니스에 대해 간단히 소개해주세요",
          businessContact: "비즈니스 연락처",
          companyWebsite: "회사 웹사이트 입력",
          businessOffers: "귀사의 비즈니스는 무엇을 제공합니까?",
          addProduct: "제품 또는 서비스 추가",

          agreeTerms: "이용 약관을 읽고, 이해했으며 동의합니다.",
          agreePrivacy: "개인정보 처리방침을 읽고, 이해했으며 동의합니다.",
          continuePrivacy: "개인정보 처리방침으로 이동",
          continuePayment: "결제 페이지로 이동",
          createBusinessAccount: "무료 iBouge 비즈니스 계정 만들기",
          createPersonalAccount: "무료 iBouge 개인 계정 만들기",
          activateMembership: "멤버십 활성화",
          planName: "요금제 이름",
          planType: "요금제 유형",
          planPrice: "요금제 가격",
          activateBusinessPage: "내 iBouge 비즈니스 페이지 활성화",

          summary: "요약",
          interests: "관심사",
          languages: "언어",
          businessOffer: "비즈니스 제안",
          openingHours: "영업 시간",
          timeZone: "시간대",
          aboutBusiness: "비즈니스 소개",
          websiteUrl: "웹사이트 URL",
          imageGallery: "이미지 갤러리",
          noImage: "갤러리에 이미지가 없습니다",
          addMore: "더 추가",
          usernameFollowing: "{{username}} 님이 팔로우 중",
          usernameFollowers: "{{username}}의 팔로워",
          shareProfile: "프로필 공유",
          editCoverPhoto: "커버 사진 수정",
          urlCopied: "URL이 클립보드에 복사되었습니다",

          upload: "업로드",
          uploading: "업로드 중",
          postDeleted: "이 게시물이 삭제되었습니다",
          activatePremium: "프리미엄 플랜 활성화",
          sharePress: "게시물 공유",
          seen: "확인됨",
          deletePicture: "사진 삭제",
          savePicture: "사진 저장",
          sharePicture: "사진 공유",
          makeCoverPicture: "커버 사진으로 설정",
          makeProfilePicture: "프로필 사진으로 설정",
          copyURL: "URL 복사",
          closed: "닫힘",
          notSet: "설정되지 않음",
          thankYou: "감사합니다!",
          loggingIntoIBouge: "iBouge에 로그인 중...",
          businessActivated: "감사합니다! 비즈니스 페이지가 활성화되었습니다.",
          shareTo: "공유 대상",
          stepFourOfFour: "4단계 중 4단계",

          step_OneTwo: "1/2 단계",
          event_details: "이벤트 세부정보",
          event_name: "이벤트 이름",
          sample_event: "최대 피자 챌린지 2022",
          event_category: "이벤트 카테고리",
          start_date: "시작 날짜",
          date_format: "yyyy/mm/dd",
          start_time: "시작 시간",
          end_time: "종료 시간",
          event_description: "이벤트 설명",
          cover_photo: "대표 사진",
          next_to_location: "위치로 이동",
          step_TwoTwo: "2/2 단계",
          enter_location: "위치 세부정보 입력",
          add_event_details: "이벤트 세부정보 추가: 지도를 클릭하세요",
          create_event: "이벤트 생성",
          users_interested: "사용자가 관심 있습니다",
          going: "참석 예정",
          not_going: "불참",
          invite: "초대",
          inviteUsers: "사용자 초대",
          typeToInvite: "사용자를 초대하려면 여기에 입력하세요",
          friendsGoing: "{{number}}명의 친구가 참석합니다.",
          usersInterested: "{{number}}명의 사용자가 관심을 보입니다",
          bookmark: "북마크",
          bookmarked: "북마크됨",

          microblog_name: "마이크로블로그 이름",
          add_location: "위치 추가: 지도에서 클릭",
          search_address: "주소 검색",
          create: "생성",
          public: "공개",
          private: "비공개",
          searchAddress: "주소를 검색하세요",
          selectImage: "이미지를 선택하세요",

          general: "일반",
          location: "위치",
          payments: "결제",

          companyWebsiteUrl: "회사 웹사이트 URL",
          settings: "설정",
          wall_private: "내 게시판을 친구에게만 비공개로 설정",
          profile_private: "내 프로필을 친구에게만 비공개로 설정",
          friends_list_private: "내 친구 목록을 친구에게만 표시",
          anyone_follow: "누구나 나를 팔로우할 수 있음",
          accept_messages: "내 친구 그룹 외부의 새 메시지를 허용",
          block_list: "차단 목록",
          block_users: "사용자 차단",
          type_to_name: "이름 입력",
          block_list_empty: "차단 목록이 비어 있습니다",

          wall_notifications: "벽 알림",
          event_invitations: "이벤트 초대",
          friend_requests: "친구 요청 알림",
          message_notifications: "메시지 알림",
          deactivateAccount: "계정 비활성화",
          deleteAccount: "계정 삭제",
          cancel: "취소",
          save: "저장",

          topCities: "인기 도시",
          chooseLocations: "최대 세 개의 위치를 선택하여 업데이트를 팔로우하세요. 새 도시로 변경하려면 도시를 선택하세요",
          city1: "도시 1",
          city2: "도시 2",
          city3: "도시 3",
          searchCity: "도시 검색",

          flagContent: "부적절한 콘텐츠 신고",
          selectReportType: "신고 유형 선택",
          unhidePost: "게시물 표시",
          hidePost: "게시물 숨기기",
          cancelSubscription: "구독 취소",
          accountUpdated: "계정이 업데이트되었습니다",
          subscriptionAmount: "구독 금액",
          subscriptionStartDate: "구독 시작일",
          subscriptionEndDate: "구독 종료일",
          locationUpdated: "위치가 업데이트되었습니다",
          notificationsUpdated: "알림이 업데이트되었습니다",
          privacyUpdated: "개인정보 보호가 업데이트되었습니다",
          undo: "실행 취소",
          block: "차단",
          unblock: "차단 해제",
          confirm: "확인",
          activateAccount: "계정 활성화",
          accountDeactivated: "이런! 현재 계정이 비활성화되어 있습니다",
          confirmDeleteAccount: "계정을 삭제하시겠습니까?",
          confirmActivateAccount: "계정을 활성화하시겠습니까?",

          delivered: "전달됨",
          download: "다운로드",
          noChatFound: "채팅을 찾을 수 없습니다",
          messageSeenBy: "다음 사용자가 메시지를 확인했습니다",
          othersCount: "+ {{number}}명 더 보기",
          notSelectedYet: "아직 선택되지 않음",
          nameTyping: "{{name}}이(가) 입력 중...",
          twoTyping: "{{name1}}와(과) {{name2}}이(가) 입력 중...",
          multipleTyping: "{{name1}}와(과) {{number}}명이 입력 중...",
          wallPrivate: "이 벽은 비공개입니다",
          profileHidden: "이 사용자의 프로필은 숨겨져 있습니다",
          profilePrivate: "이 사용자의 프로필은 비공개입니다",
          follow: "팔로우",
          following: "팔로잉",
          and: "그리고",
          others: "{{number}}명 더 보기",
          acceptFriendRequest: "친구 요청 수락",
          friendRequestSent: "친구 요청이 전송되었습니다",
          friends: "친구",
          confirmUnfollow: "언팔로우하시겠습니까?",
          confirmUnfriend: "친구를 삭제하시겠습니까?",
          upgradeMessage: "비즈니스 페이지에서 무제한 팔로워를 이용하려면 프리미엄 요금제로 업그레이드하세요.",
          upgrade: "업그레이드",

          noConnectionsFound: "연결된 사용자가 없습니다",
          followersPrivate: "이 사용자의 팔로워 목록은 비공개입니다",
          friendsPrivate: "이 사용자의 친구 목록은 비공개입니다",
          addAsFriend: "친구로 추가",
          add: "추가",
          unfriend: "친구 끊기",
          unfollow: "따르다",
          chat: "채팅",
          inviteToChat: "채팅에 초대",
        }
      },
      ar: {
        dir: "rtl",
        translation: {

          introducing: "تقديم iBouge",
          whatIsIBouge: "ما هو iBouge<0>®</0>؟",
          ibougeIntro: "iBouge هي منصة خرائط تضع الأشخاص والمنتجات والمعلومات على واجهة خريطة عالمية لتصبح أكثر سهولة في الوصول وأسهل في العثور عليها من قبل مستخدمي الإنترنت حول العالم، مما يتيح لهم التفاعل بطرق جديدة.",
          ibougeDescription: "واجهة الخريطة العالمية الفريدة والحاصلة على براءة اختراع من iBouge ® تصنف المحتوى بطريقة جديدة وتسمح للأشخاص بأن يتم العثور عليهم وللمحتوى بأن يُشاهد على نطاق عالمي. يمكن لمستخدمي iBouge ® التواصل مع أي شخص في العالم ويمكن للشركات الوصول إلى أي جمهور في أي مكان بغض النظر عن موقعهم.",
          sign_up: "إنشاء حساب",
          howDoISignUp: "حسنًا، لقد اقتنعت،<1/><0>كيف يمكنني التسجيل؟</0>",
          products_intro: "نحن نقدم حاليًا 4 منتجات على واجهة خريطتنا:",
          product1: "التعرف على أشخاص بالقرب منك",
          product2: "صفحات الأعمال العالمية",
          product3: "محادثات قائمة على الخريطة حول نقاط الاهتمام",
          product4: "الأحداث المحلية المثبتة على خريطتنا والمُعلنة لأي شخص يتابع تلك المنطقة.",
          whatDifferentiates: "<0>ما الذي يميز المنصة </0>عن شركات وسائل التواصل الاجتماعي الأخرى؟",
          business_price: "صفحات الأعمال لدينا تكلف فقط 25 دولارًا سنويًا مع ظهور عالمي.",
          signup_cta: "سجّل نشاطك التجاري الآن مقابل 25 دولارًا فقط سنويًا",

          whoShouldSignUp: "من يجب أن يسجل حسابًا ولماذا؟",
          twoTypesAccounts: "نحن نقدم نوعين من الحسابات.",
          businessAccountDescription: "صفحات أعمالنا العالمية مصممة خصيصًا للشركات الصغيرة التي تبحث عن انتشار تسويقي واسع وظهور دولي فوري.",
          businessPageFeatures: "صفحات الأعمال لدينا تسرد معلومات شركتك تمامًا مثل خرائط Google مع إمكانية العثور عليها على الخريطة، ولكن مع ميزة إضافية وهي الدردشة الجماعية، والمراسلة المباشرة، وميزات التواصل الاجتماعي، وجدار شخصي خاص بعلامتك التجارية وتحديثات شركتك.",
          accountTypes: "حسابات شخصية فردية مجانية وحسابات أعمال مدفوعة.",
          soldQuestion: "حسنًا، لقد اقتنعت، كيف يمكنني التسجيل؟",
          signUpInstructions: "يمكنك التسجيل كمستخدم مجاني أو كمستخدم تجاري مدفوع في صفحة التسجيل الخاصة بنا واختيار نوع الحساب الذي تريده من قائمة نوع الحساب.",
          step1: "الخطوة 1",
          step2: "الخطوة 2",
          step3: "الخطوة 3",
          step4: "الخطوة 4",
          done: "تم",
          step1_desc: "املأ تفاصيل الشركة، أضف موقع الشركة الإلكتروني وصورة الملف الشخصي للشركة.",
          step2_desc: "قم بتمكين المتصفح لمشاركة موقعه مع iBouge ® حتى نتمكن من تحديد موقع عملك على الخريطة.",
          step3_desc: "اختر أفضل ثلاث مدن مفضلة لديك لمتابعة التحديثات في موجز الأخبار الخاص بك. يمكنك تغيير هذه المدن في أي وقت لاستكشاف أماكن جديدة.",
          step4_desc: "أدخل تفاصيل بطاقتك الائتمانية لبدء عضويتك الجديدة باستخدام شريك المعاملات الآمن لدينا Stripe.",
          enjoyBenefits: "وابدأ بالاستمتاع بمزايا استخدام منصتنا",
          done_steps: "سيتم تفعيل صفحة عملك تلقائيًا ثم تسجيل الدخول إلى المنصة.",

          profileUpdated: "تم تحديث الملف الشخصي",
          deactivateConfirm: "هل أنت متأكد أنك تريد تعطيل الحساب؟",
          enterTextOrImage: "يرجى إدخال نص أو تحديد صورة",
          fileTooBig: "حجم الملف كبير جدًا",
          selectFileFirst: "يرجى تحديد ملف أولاً",
          waitForUpload: "يرجى الانتظار حتى يتم تحميل الوسائط",
          alreadyExistInGroup: "المستخدم موجود بالفعل في المجموعة",
          enterMsgFirst: "يرجى إدخال الرسالة أولاً",
          someFilesTooBig: "بعض الملفات كانت كبيرة جدًا ولم يتم تحديدها.",
          enterMessage: "أدخل الرسالة",
          enterNewPassword: "يرجى إدخال كلمة المرور الجديدة الخاصة بك",

          contact_us: "اتصل بنا",
          write_to_us: "اكتب إلينا",
          message_intro: "يسعدنا سماع رأيك! يرجى ترك رسالة وسنرد عليك قريبًا.",
          your_name: "اسمك",
          subject: "الموضوع",
          query: "الاستفسار",
          send_message: "إرسال الرسالة",
          message: "الرسالة",
          submit: "إرسال",
          global_hq: "المقر الرئيسي العالمي:",
          address: "ريدموند، واشنطن 98052، الولايات المتحدة الأمريكية",
          hours: "الإثنين - الجمعة: 9:00 - 17:00 بتوقيت المحيط الهادئ",

          mission_title: "مهمة iBouge",
          population_globe: "كرة السكان",
          expanding_world: "توسيع عالمك",
          platform_intro: "تتيح منصة iBouge® الحاصلة على براءة اختراع للمستخدمين العثور على الشركات والأشخاص والمعلومات في أي بلد في العالم. تصاميم خريطتنا تخلق منصة عالمية مفتوحة للبحث عن الأعمال، والتواصل مع أشخاص جدد، والمشاركة في المجتمعات التي تهمك.",
          mission_statement: "مهمتنا هي أن نكون أكثر بوابة معلومات انفتاحًا على الويب للأشخاص والشركات والمجتمعات.",
          platform_use: "مع iBouge، يمكنك العثور على أي شخص في العالم أو أي شركة عالميًا دون كتابة أي كلمات بحث. فقط انقر على خريطتنا وقرّب لتجد الشركات في الأماكن التي تهتم بها أو الأشخاص الذين ترغب في مقابلتهم.",
          shops_future: "سنقوم قريبًا بفتح متاجر لبيع المنتجات على منصتنا لتتمكن من التسوق حسب الموقع.",
          global_connect: "العالم أصبح أكثر ترابطًا من أي وقت مضى، وiBouge مصمم لجعل معلوماتك مركزية ومفتوحة حتى لا تكون هناك حدود للمكان الذي تشتري منه أو من تتواصل معه أو المجتمعات التي تنتمي إليها.",
          fingertips: "مع iBouge، العالم في متناول يديك.",

          press_statement: "بيان صحفي",
          month: "شهر",
          year: "سنة",
          search_article: "بحث عن مقالة",
          lisa_leslie: "ليزا ليزلي",
          lisa_title: "بلا حدود: كيف تجعل ليزا ليزلي العالم أصغر قليلًا",
          lisa_updated: "آخر تحديث 07/05/2019",
          lisa_description: "بدأ شغف ليزا ليزلي بالتكنولوجيا منذ سن مبكرة. نشأت وهي تلعب الألعاب على كمبيوتر العائلة وكانت تستغل كل فرصة لاستكشاف الإنترنت.",
          read_article: "اقرأ المقال",
          card_cap: "عنوان البطاقة",
          ibouge_title: "iBouge تطلق منصة شبكات جغرافية عالمية للشركات",
          ibouge_updated: "آخر تحديث 07/05/2019",
          ibouge_now_description: "تقدم iBouge الآن صفحات أعمال للشركات في كل مكان. يمكن للشركات التسجيل على منصة الخرائط والوصول إلى جمهور عالمي على الفور.",

          dashboard: "لوحة التحكم الخاصة بي",
          mapOverview: "نظرة عامة على الخريطة",
          businessProfile: "ملف العمل",
          admin: "المسؤول",
          about: "حول",
          contact: "اتصال",
          mission: "المهمة",
          demo: "عرض توضيحي",
          press: "الصحافة",
          blog: "مدونة",
          privacy: "الخصوصية",
          terms: "شروط الخدمة",

          typeToSearch: "اكتب للبحث",
          searching: "جارٍ البحث...",
          account: "الحساب",
          notifications: "الإشعارات",
          inbox: "البريد الوارد",
          logout: "تسجيل الخروج",

          users: "المستخدمون",
          events: "الفعاليات",
          microblogs: "المدونات المصغّرة",
          business: "الأعمال",
          myProfile: "ملفي الشخصي",

          globalNewsFeed: "الموجز الإخباري العالمي",
          whatsOnMind: "بماذا تفكر؟",
          usePhoto: "استخدام صورة",
          close: "إغلاق",
          usernameWall: "حائط {{username}}",
          noStatusUpdates: "لا توجد تحديثات للحالة هنا",
          typing: "يكتب الآن",
          hidePostsInfo: "إخفاء المنشورات يساعد iBouge على تخصيص وتحسين المحتوى الخاص بك",
          hidden: "مخفي",
          post: "نشر",
          reportPost: "الإبلاغ عن المنشور",
          deletePost: "حذف المنشور",
          writeComment: "اكتب تعليقًا",
          deleteComment: "حذف التعليق",
          addCommentText: "يرجى إضافة بعض النص في التعليق",
          noPosts: "عذرًا! لا توجد منشورات متاحة لهذا الموقع بعد. جرّب موقعًا آخر.",
          startConversation: "ابدأ محادثة",
          friendsSelected: "تم اختيار صديق/أصدقاء",

          localEvents: "الفعاليات المحلية",
          myMicroblogs: "مدوناتي المصغّرة",
          edit: "تعديل",
          addNew: "إضافة جديد",

          addCity: "أضف مدينة",
          usernameConnection: "اتصالات {{username}}",
          selectOneFriend: "يرجى اختيار صديق واحد على الأقل",
          createGroup: "إنشاء مجموعة",
          noChats: "لا توجد محادثات متاحة",
          noNotifications: "لا توجد إشعارات",
          addNewEvent: "إضافة فعالية جديدة",
          addNewMicroblog: "إضافة مدونة مصغّرة جديدة",
          addEvent: "إضافة فعالية",
          addMicroblog: "إضافة مدونة مصغّرة",

          signUp: "إنشاء حساب",
          signIn: "تسجيل الدخول",
          login: "تسجيل الدخول",
          signupSteps: "قم بإنشاء حسابك في بضع خطوات بسيطة",
          welcomeLogin: "مرحبًا! سجّل الدخول إلى حسابك",
          email: "عنوان البريد الإلكتروني",
          password: "كلمة المرور",
          confirmPassword: "تأكيد كلمة المرور",
          type: "النوع",
          personalAccount: "حساب شخصي",
          businessAccount: "حساب أعمال",
          firstName: "الاسم الأول",
          lastName: "اسم العائلة",
          gender: "الجنس",
          male: "ذكر",
          female: "أنثى",
          preferNotSay: "أفضل عدم القول",
          other: "آخر",
          continue: "متابعة",
          forgetPassword: "هل نسيت كلمة المرور؟",
          loginMyAccount: "تسجيل الدخول إلى حسابي",
          noAccount: "ليس لديك حساب؟",
          alreadyAccount: "هل لديك حساب بالفعل؟",

          businessCategory: "فئة النشاط التجاري",
          subscriptionType: "نوع الاشتراك",
          selectPlan: "اختر خطة",
          freePlan: "الخطة المجانية",
          premiumPlan: "الخطة المميزة",
          businessName: "اسم النشاط التجاري",
          fillField: "يرجى ملء الحقل، شكرًا لك",
          loginVerified: "يرجى تسجيل الدخول بعد التحقق",
          loginNewAccount: "يرجى تسجيل الدخول باستخدام بيانات الحساب الجديدة التي أنشأتها",
          accountDisabled: "تم تعطيل حسابك من قبل المسؤول.",
          premiumOffer: "توفر iBouge Premium عدد غير محدود من المتابعين ونتائج بحث أولوية لصفحتك التجارية.",

          enterOtp: "يرجى إدخال رمز التحقق (OTP) المرسل إلى البريد الإلكتروني أدناه:",
          emailVerification: "التحقق من البريد الإلكتروني",
          resendOtp: "إعادة إرسال الرمز",
          otpExpires: "ينتهي رمز التحقق خلال {{time}} دقيقة",
          verify: "تحقق",
          restorePasswordText: "أدخل بريدك الإلكتروني وسنساعدك على استعادة الوصول.",
          restorePassword: "استعادة كلمة المرور",
          createNewPassword: "إنشاء كلمة مرور جديدة",
          back: "رجوع",
          patentNumbers: "أرقام براءات الاختراع",
          copyright: "حقوق النشر",
          allRightsReserved: "جميع الحقوق محفوظة",

          setup_stepOne: "الإعداد 1/3",
          setup_profile: "إعداد ملفك الشخصي",
          about_me: "نبذة عني",
          about_me_placeholder: "أخبرنا قليلًا عن نفسك",
          my_interests: "اهتماماتي",
          add_interests: "أضف اهتمامات",
          my_languages: "لغاتي",
          add_languages: "أضف لغات",

          setup_stepTwo: "الإعداد 2/3",
          setup_location: "إعداد موقعك",
          add_your_location: "أضف موقعك: انقر على الخريطة",
          enable_location: "يرجى تفعيل الموقع في متصفحك لتحديد منطقتك البريدية.",
          tag_neighborhood: "يرجى تحديد موقعك ضمن الحي الذي تسكن فيه لتحصل على أفضل المعلومات المجتمعية والعثور على أشخاص من حولك.",
          location_access: "نحتاج إلى إذن للوصول إلى موقع جهازك لتقديم توصيات مخصصة ومحتوى ذي صلة وتحسين الأداء. لا يتم الوصول إلى موقعك إلا أثناء استخدام التطبيق.",

          setup_stepThree: "الإعداد 3/3",
          select_cities: "اختر 3 مدن لمتابعة أخبار المجتمع والتحديثات",
          first_city: "المدينة الأولى",
          search: "بحث",
          second_city: "المدينة الثانية",
          third_city: "المدينة الثالثة",
          selectFirstCity: "يرجى اختيار المدينة الأولى",
          enterOneCity: "يرجى إدخال مدينة واحدة على الأقل أولًا",

          step_oneFour: "الإعداد 1/4",
          businessSummary: "ملخص العمل",
          businessSummary_placeholder: "أخبرنا قليلاً عن عملك",
          businessContact: "جهة اتصال العمل",
          companyWebsite: "أدخل موقع الشركة الإلكتروني",
          businessOffers: "ماذا يقدم عملك؟",
          addProduct: "أضف منتجًا أو خدمة",

          agreeTerms: "لقد قرأت وفهمت وأوافق على الشروط والأحكام.",
          agreePrivacy: "لقد قرأت وفهمت وأوافق على سياسة الخصوصية.",
          continuePrivacy: "المتابعة إلى سياسة الخصوصية",
          continuePayment: "المتابعة إلى صفحة الدفع",
          createBusinessAccount: "إنشاء حساب أعمال مجاني في iBouge",
          createPersonalAccount: "إنشاء حساب شخصي مجاني في iBouge",
          activateMembership: "تفعيل العضوية",
          planName: "اسم الخطة",
          planType: "نوع الخطة",
          planPrice: "سعر الخطة",
          activateBusinessPage: "تفعيل صفحتي التجارية على iBouge",

          summary: "الملخص",
          interests: "الاهتمامات",
          languages: "اللغات",
          businessOffer: "عروض العمل",
          openingHours: "ساعات العمل",
          timeZone: "المنطقة الزمنية",
          aboutBusiness: "نبذة عن العمل",
          websiteUrl: "رابط الموقع الإلكتروني",
          imageGallery: "معرض الصور",
          noImage: "لم يتم العثور على صور في المعرض",
          addMore: "أضف المزيد",
          usernameFollowing: "{{username}} يتابع",
          usernameFollowers: "متابعو {{username}}",
          shareProfile: "مشاركة الملف الشخصي",
          editCoverPhoto: "تعديل صورة الغلاف",
          urlCopied: "تم نسخ الرابط إلى الحافظة",

          upload: "رفع",
          uploading: "جارٍ الرفع",
          postDeleted: "تم حذف هذا المنشور",
          activatePremium: "تفعيل الخطة المميزة",
          sharePress: "مشاركة المنشور",
          seen: "تمت المشاهدة",
          deletePicture: "حذف الصورة",
          savePicture: "حفظ الصورة",
          sharePicture: "مشاركة الصورة",
          makeCoverPicture: "تعيين كصورة الغلاف",
          makeProfilePicture: "تعيين كصورة الملف الشخصي",
          copyURL: "نسخ الرابط",
          closed: "مغلق",
          notSet: "غير محدد",
          thankYou: "شكرًا لك!",
          loggingIntoIBouge: "جارٍ تسجيل دخولك إلى iBouge خلال",
          businessActivated: "شكرًا لك! تم تفعيل صفحتك التجارية الآن.",
          shareTo: "المشاركة في",
          stepFourOfFour: "الخطوة 4 من 4",

          step_OneTwo: "الخطوة 1/2",
          event_details: "تفاصيل الحدث",
          event_name: "اسم الحدث",
          sample_event: "أكبر تحدي بيتزا 2022",
          event_category: "فئة الحدث",
          start_date: "تاريخ البدء",
          date_format: "mm/dd/yyyy",
          start_time: "وقت البدء",
          end_time: "وقت الانتهاء",
          event_description: "وصف الحدث",
          cover_photo: "صورة الغلاف",
          next_to_location: "التالي إلى الموقع",
          step_TwoTwo: "الخطوة 2/2",
          enter_location: "أدخل تفاصيل الموقع",
          add_event_details: "أضف تفاصيل الحدث: انقر على الخريطة",
          create_event: "إنشاء حدث",
          users_interested: "المستخدمون المهتمون",
          going: "ذاهب",
          not_going: "غير ذاهب",
          invite: "دعوة",
          inviteUsers: "دعوة المستخدمين",
          typeToInvite: "اكتب هنا لدعوة المستخدم",
          friendsGoing: "{{number}} من أصدقائك ذاهبون.",
          usersInterested: "{{number}} مستخدمين مهتمين",
          bookmark: "إشارة مرجعية",
          bookmarked: "تمت الإشارة",

          microblog_name: "اسم الميكروبلاگ",
          add_location: "أضف الموقع: انقر على الخريطة",
          search_address: "ابحث عن عنوان",
          create: "إنشاء",
          public: "عام",
          private: "خاص",
          searchAddress: "يرجى البحث عن عنوان",
          selectImage: "يرجى تحديد الصورة",

          general: "عام",
          location: "الموقع",
          payments: "المدفوعات",

          companyWebsiteUrl: "رابط موقع الشركة الإلكتروني",
          settings: "الإعدادات",
          wall_private: "اجعل جداري خاصًا للأصدقاء فقط",
          profile_private: "اجعل ملفي الشخصي خاصًا لأصدقائي فقط",
          friends_list_private: "إظهار قائمة أصدقائي لأصدقائي فقط",
          anyone_follow: "يمكن لأي شخص متابعتي",
          accept_messages: "أقبل الرسائل الجديدة من خارج مجموعة أصدقائي",
          block_list: "قائمة الحظر",
          block_users: "حظر المستخدمين",
          type_to_name: "اكتب الاسم",
          block_list_empty: "قائمة الحظر فارغة",

          wall_notifications: "إشعارات الجدار",
          event_invitations: "دعوات الأحداث",
          friend_requests: "إشعارات طلبات الصداقة",
          message_notifications: "إشعارات الرسائل",
          deactivateAccount: "تعطيل الحساب",
          deleteAccount: "حذف الحساب",
          cancel: "إلغاء",
          save: "حفظ",

          topCities: "المدن الأعلى",
          chooseLocations: "اختر ما يصل إلى ثلاث مواقع لمتابعة التحديثات. حدد مدينة لتحديثها إلى مدينة جديدة",
          city1: "المدينة 1",
          city2: "المدينة 2",
          city3: "المدينة 3",
          searchCity: "ابحث عن مدينة",

          flagContent: "الإبلاغ عن محتوى غير لائق",
          selectReportType: "اختر نوع التقرير",
          unhidePost: "إظهار المنشور",
          hidePost: "إخفاء المنشور",
          cancelSubscription: "إلغاء الاشتراك",
          accountUpdated: "تم تحديث الحساب",
          subscriptionAmount: "مبلغ الاشتراك",
          subscriptionStartDate: "تاريخ بدء الاشتراك",
          subscriptionEndDate: "تاريخ انتهاء الاشتراك",
          locationUpdated: "تم تحديث الموقع",
          notificationsUpdated: "تم تحديث الإشعارات",
          privacyUpdated: "تم تحديث الخصوصية",
          undo: "تراجع",
          block: "حظر",
          unblock: "إلغاء الحظر",
          confirm: "تأكيد",
          activateAccount: "تفعيل الحساب",
          accountDeactivated: "عذرًا! حسابك معطل حاليًا",
          confirmDeleteAccount: "هل أنت متأكد أنك تريد حذف الحساب؟",
          confirmActivateAccount: "هل أنت متأكد أنك تريد تفعيل الحساب؟",

          delivered: "تم التسليم",
          download: "تنزيل",
          noChatFound: "لم يتم العثور على محادثة",
          messageSeenBy: "تمت مشاهدة الرسالة بواسطة المستخدم التالي",
          othersCount: "+ {{number}} آخرين",
          notSelectedYet: "لم يتم الاختيار بعد",
          nameTyping: "{{name}} يكتب...",
          twoTyping: "{{name1}} و {{name2}} يكتبان...",
          multipleTyping: "{{name1}} و {{number}} آخرين يكتبون...",
          wallPrivate: "هذا الجدار خاص",
          profileHidden: "الملف الشخصي لهذا المستخدم مخفي",
          profilePrivate: "ملف هذا المستخدم خاص",
          follow: "متابعة",
          following: "متابَع",
          and: "و",
          others: "{{number}} آخرين",
          acceptFriendRequest: "قبول طلب الصداقة",
          friendRequestSent: "تم إرسال طلب الصداقة",
          friends: "الأصدقاء",
          confirmUnfollow: "هل أنت متأكد أنك تريد إلغاء المتابعة؟",
          confirmUnfriend: "هل أنت متأكد أنك تريد إلغاء الصداقة؟",
          upgradeMessage: "يرجى الترقية إلى خطتنا المميزة لفتح عدد غير محدود من المتابعين على صفحة عملك.",
          upgrade: "ترقية",

          noConnectionsFound: "لم يتم العثور على أي اتصالات",
          followersPrivate: "قائمة المتابعين لهذا المستخدم خاصة",
          friendsPrivate: "قائمة الأصدقاء لهذا المستخدم خاصة",
          addAsFriend: "إضافة كصديق",
          add: "إضافة",
          unfriend: "إلغاء الصداقة",
          unfollow: "إلغاء المتابعة",
          chat: "دردشة",
          inviteToChat: "دعوة للدردشة",
        }
      }
    },

    fallbackLng: "English",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;